import {
  AgentStatus,
  CallStatus,
  CaseStatus,
  HotelCategories,
  SALE_ORDER_STATUS,
  WhatsappMessageEventStatusType,
} from '@bandido/shared/constants';
import {
  InvalidationRuleFieldOptionHotels,
  InvalidationRuleOperator,
  IVRActionType,
  MarkupFieldOptionHotels,
  MarkupRuleOperator,
  NotificationType,
  UserRoles,
  OriginatedByChannel,
} from '@bandido/shared/types';
import { CommunicationType, TimeoutAction } from '@bandido/shared/types';
import { WELCOME_MESSAGE } from '@frontend/features/calls-menu/constants';

export const english = {
  filters: {
    filterBy: 'Filter by',
    clear: 'Clear',
    clearAll: 'Clear all',
    namePlaceholder: 'Write a name',
    nameLabel: 'Filter name',
    isPublic: 'Public (everyone would see it)',
    createFilter: 'Create Filter',
    filterList: 'Filter list',
    editFilter: 'Edit Filter',
    deleteFilter: 'Delete Filter',
    public: 'Public',
    private: 'Private',
    createdSuccess: 'Filter created',
    createdError: 'There was an error while creating your filter',
    deletedSuccess: 'Filter deleted successfully',
    deletedError: 'There was an error while deleting your filter',
    deleteConfirmTitle: 'Delete Filter',
    deleteConfirmMessage: 'Are you sure you want to delete this filter? This action cannot be undone.',
    priceRange: 'Price range',
    searchName: 'Search by name',
    hotelChains: 'Hotel Chains',
    categories: 'Categories',
    amenities: 'Amenities',
    myClients: 'View only my clients',
    myCases: 'View only my cases',
    date: {
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      thisMonth: 'This month',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      lastNDays: 'Last N days',
      tomorrow: 'Tomorrow',
      nextWeek: 'Next week',
      nextMonth: 'Next month',
      nextNDays: 'Next N days',
      specificDate: 'Specific date',
      dateRange: 'Date range',
      numberOfDays: 'Number of days',
      from: 'From',
      to: 'To',
      selectDateType: 'Select date type',
    },
  },
  whatsapp: {
    chatLocation: {
      location: 'Location',
    },
    title: 'Whatsapp',
    systemSender: 'Agency',
    noMessagesFound: 'No messages found..',
    typeMessage: 'Type your message...',
    startWithTemplate: 'Start with a template',
    templateMessenger: {
      title: 'Send message from template',
      selectTemplate: 'Select a template',
      preview: 'Preview:',
      completeFields: 'Complete the fields:',
      placeholder: 'Placeholder {{number}}',
      sendMessage: 'Send message',
      fileSelected: 'File selected',
      fileRequired: 'A file is required for this template',
      uploadFile: 'Upload file',
      noFileSelected: 'No file selected',
      selectFile: 'Select file',
    },
    results: 'results',
    table: {
      clientName: 'Client name',
      fromNumber: 'Phone number',
      conversation: 'Conversation',
      agency: 'Agency',
      msgType: 'Message type',
      expiration: 'Expiration',
    },
    client: {
      lastCases: 'Last Cases',
      noCases: 'No cases to show',
      conversation: 'Whatsapp Conversation',
      searchPlaceholder: 'Search in conversation',
      writeMessage: 'Write a message',
      sendTemplate: 'Send Template',
      aiEnabled: 'AI Enabled',
      sentTo: 'sent to',
    },
    content: {
      whatsapp: 'Whatsapp',
      email: 'Email',
      phone: 'Phone',
      files: 'Files',
      notes: 'Notes',
      history: 'History',
      all: 'All',
      show: 'Show',
      search: 'Search...',
      viewMore: 'View more',
      now: 'Now',
      minutesAgo: '{{minutes}} minutes ago',
      sessionExpired: 'Session expired',
      timeLeft: 'Time left',
    },
    messageTypes: {
      text: 'Text',
      contacts: 'Contacts',
      template: 'Template',
      sticker: 'Sticker',
      audio: 'Audio',
      video: 'Video',
      image: 'Image',
      document: 'Document',
      location: 'Location',
    },
    emoji: {
      categories: {
        favoritos: 'Favorites',
        smileys_emotion: 'Smileys & Emotion',
        people_body: 'People & Body',
        travel_places: 'Travel & Places',
        food_drink: 'Food & Drink',
        activities: 'Activities',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags',
      },
      names: {
        airplane: 'airplane',
        globe: 'globe',
        telephone: 'telephone',
        speech_balloon: 'speech balloon',
        handshake: 'handshake',
        smiling_face: 'smiling face',
        face_with_hearts: 'face with hearts',
        hugging_face: 'hugging face',
        star_struck: 'star-struck',
        folded_hands: 'folded hands',
        thumbs_up: 'thumbs up',
        raising_hands: 'raising hands',
        briefcase: 'briefcase',
        incoming_envelope: 'incoming envelope',
        rocket: 'rocket',
        check_mark: 'check mark',
        alarm_clock: 'alarm clock',
        dollar_sign: 'dollar sign',
        red_heart: 'red heart',
        party_popper: 'party popper',
        grinning_face: 'grinning face',
        beaming_face: 'beaming face',
        face_with_tears: 'face with tears',
        grinning_face_with_sweat: 'grinning face with sweat',
        smiling_face_with_sunglasses: 'smiling face with sunglasses',
        thinking_face: 'thinking face',
        face_with_rolling_eyes: 'face with rolling eyes',
        crying_face: 'crying face',
        smiling_face_with_heart_eyes: 'smiling face with heart-eyes',
        pouting_face: 'pouting face',
        sleeping_face: 'sleeping face',
        partying_face: 'partying face',
        waving_hand: 'waving hand',
        thumbs_down: 'thumbs down',
        open_hands: 'open hands',
        clapping_hands: 'clapping hands',
        call_me_hand: 'call me hand',
        flexed_biceps: 'flexed biceps',
        car: 'car',
        bus: 'bus',
        train: 'train',
        sailboat: 'sailboat',
        passenger_ship: 'passenger ship',
        statue_of_liberty: 'Statue of Liberty',
        world_map: 'world map',
        eiffel_tower: 'Eiffel Tower',
        green_apple: 'green apple',
        hamburger: 'hamburger',
        pizza: 'pizza',
        sushi: 'sushi',
        steaming_bowl: 'steaming bowl',
        shortcake: 'shortcake',
        beer_mug: 'beer mug',
        hot_beverage: 'hot beverage',
        wine_glass: 'wine glass',
        bottle_with_popping_cork: 'bottle with popping cork',
        soccer_ball: 'soccer ball',
        basketball: 'basketball',
        american_football: 'american football',
        tennis: 'tennis',
        volleyball: 'volleyball',
        video_game: 'video game',
        musical_note: 'musical note',
        clapper_board: 'clapper board',
        artist_palette: 'artist palette',
        broken_heart: 'broken heart',
        hundred_points: 'hundred points',
        cross_mark: 'cross mark',
        warning: 'warning',
        information: 'information',
        bell: 'bell',
        ok_button: 'OK button',
        recycling_symbol: 'recycling symbol',
        uruguay_flag: 'flag: Uruguay',
        paraguay_flag: 'flag: Paraguay',
        bolivia_flag: 'flag: Bolivia',
        colombia_flag: 'flag: Colombia',
        usa_flag: 'flag: United States',
        brazil_flag: 'flag: Brazil',
        argentina_flag: 'flag: Argentina',
        mexico_flag: 'flag: Mexico',
        chile_flag: 'flag: Chile',
        spain_flag: 'flag: Spain',
        star: 'star',
        glowing_star: 'glowing star',
        sparkles: 'sparkles',
        dizzy: 'dizzy',
        shooting_star: 'shooting star',
      },
      selectEmoji: 'Choose an emoji',
      searchPlaceholder: 'Type here to search',
    },
    messageStatus: {
      [WhatsappMessageEventStatusType.REQUESTED]: 'requested',
      [WhatsappMessageEventStatusType.ENQUEUED]: 'queued',
      [WhatsappMessageEventStatusType.FAILED]: 'failed',
      [WhatsappMessageEventStatusType.SENT]: 'sent',
      [WhatsappMessageEventStatusType.DELIVERED]: 'delivered',
      [WhatsappMessageEventStatusType.READ]: 'read',
    },
    settings: {
      title: 'Gupshup settings',
      createNewSubscription: 'Create new subscription',
      tag: 'Tag',
      url: 'URL',
      version: 'Version',
      showOnUI: 'Show on UI',
      modes: 'Modes',
    },
    iaReasoning: {
      viewReasoning: 'View AI Reasoning',
      hideDetails: 'Hide details',
      viewCompleteAnalysis: 'View complete analysis',
      contextAnalysis: 'Context Analysis',
    },
  },
  userNotificationTriggers: {
    title: 'Notification Management',
    createTrigger: 'Create Trigger',
    editTrigger: 'Edit Trigger',
    deleteTrigger: 'Delete Trigger',
    trigger: 'Trigger',
    active: 'Active',
    noConditions: 'No specific conditions',
    client: 'Client',
    agent: 'Agent',
    workflow: 'Workflow',
    step: 'Step',
    status: 'Status',
    case: 'Case',
    specificCase: 'Specific case (optional)',
    selectClient: 'Select client',
    selectAgent: 'Select agent',
    selectWorkflow: 'Select workflow(s)',
    selectStep: 'Select step',
    selectStatus: 'Select status',
    selectWorkflowFirst: 'First select a workflow',
    caseIdPlaceholder: 'Case ID',
    allClients: 'All clients',
    allAgents: 'All agents',
    anyStep: 'Any step',
    allWorkflows: 'All workflows',
    anyStatus: 'Any status',
    anyCase: 'Any case',
    formDescription:
      'Configure the conditions that will trigger a notification. At least one condition must be specified.',
    noTriggers: 'No triggers configured',
    noTriggersDescription: 'Create your first trigger to receive automatic notifications.',
    createFirst: 'Create first trigger',
    createdBy: 'Created by',
    confirmDelete: {
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this trigger? This action cannot be undone.',
      triggerDetails: 'Trigger Details',
      warning: 'This action will permanently delete the trigger and cannot be reverted.',
    },
    fields: {
      client: 'Client',
      agent: 'Agent',
      workflow: 'Workflow',
      step: 'Step',
      status: 'Status',
    },
    createSuccess: 'Trigger created successfully',
    updateSuccess: 'Trigger updated successfully',
    deleteSuccess: 'Trigger deleted successfully',
    saveError: 'Error saving trigger',
    deleteError: 'Error deleting trigger',
    activatedSuccess: 'Trigger activated',
    deactivatedSuccess: 'Trigger deactivated',
    toggleError: 'Error toggling trigger status',
  },
  agencyAccess: {
    title: 'Agency Access',
    saveError: 'An error ocurrer while updating user agency access permissions',
  },
  updateClientAgency: {
    updateSuccess: 'Agency updated!',
    updateError: 'An error occurred while updating the agency',
    title: 'Reponsible Agency',
    inputLabel: 'Select Agency',
    confirm: 'Confirm Changes',
    dialog1: 'Changing the user agency will trigger several changes',
    dialog2: 'User will not be part of the previous agency teams he might have been part of',
    dialog3: 'All cases beloging to this user will change the ownership to unassigned',
    dialog4: 'Are you sure you want to proceed?',
  },
  agentAvailability: {
    title: 'Available agents',
    status: 'Status',
    agent: 'Agent',
    since: 'Since',
  },
  agentStatus: {
    [AgentStatus.AFTER_CALL]: 'After Call',
    [AgentStatus.AVAILABLE]: 'Available',
    [AgentStatus.BREAK]: 'On Break',
    [AgentStatus.IN_CALL]: 'In Call',
    [AgentStatus.LUNCH]: 'At lunch',
    [AgentStatus.NOT_AVAILABLE]: 'Do not disturb',
    [AgentStatus.NOT_APPLICABLE]: 'Not Applicable',
    [AgentStatus.WORKING_IN_CASE]: 'Working in a case',
    [AgentStatus.DISCONNECTED]: 'Disconnected',
  },
  roles: {
    title: 'Roles',
    [UserRoles.ADMINS]: 'Administrator',
    [UserRoles.AGENTS]: 'Agent',
    [UserRoles.OPERATORS]: 'Operator',
    [UserRoles.REGISTERED]: 'Registered',
    [UserRoles.HOTEL_CONTENT_MODERATOR]: 'Hotel content moderator',
    [UserRoles.EXTERNAL_INTEGRATION]: 'External integration',
    [UserRoles.TESTER]: 'Tester',
    [UserRoles.HOTEL_BOOKER]: 'Hotel Booker',
  },
  calls: {
    subtitle: 'System calls list',
    table: {
      title: 'Calls',
      type: 'Type',
      from: 'From',
      to: 'To',
      agent: 'Agent',
      status: 'Status',
      duration: 'Duration',
      inbound: 'Inbound',
      outbound: 'Outbound',
      notAssigned: 'Not assigned',
    },
    status: {
      [CallStatus.COMPLETED]: 'Completed',
      [CallStatus.IN_PROGRESS]: 'In progress',
      [CallStatus.DECLINED]: 'Declined',
    },
    incoming: {
      title: 'Incoming call',
      callFrom: 'Call from {{phoneNumber}}',
      unknown: 'Unknown',
      contentSubtitle: 'Is calling you',
      answer: 'Answer',
      phone: 'Phone',
      decline: 'Decline',
      transfer: {
        title: 'Transfer call',
        searchPlaceholder: 'Search user',
        freqUsers: 'Frequent users',
        calling: 'Calling...',
        joined: 'In progress',
      },
    },
    interaction: {
      title: 'Enable call reception',
      description: 'To receive calls and play sounds automatically, you need to click anywhere on the screen.',
      enable: 'Enable calls',
      enable_audio: 'Enable sound',
      banner_message: 'Click here to enable incoming call sounds. You can also click anywhere on the page.',
    },
    assignment: {
      title: 'Call details',
      search: 'Search case',
      newCase: 'New case',
      caseId: 'Case ID',
      success: 'Call assigned successfully',
      error: 'There was a problem assigning the call',
      flow: 'Flow',
      client: 'Client',
      clientUnassigned: 'Unassigned',
      step: 'Step',
      status: 'Status',
      team: 'Team',
      assignedTo: 'Assigned agent',
      link: 'Link to this case',
      create: {
        title: 'Create new case',
        cancel: 'Cancel',
        accept: 'Create',
        subject: 'Case subject',
        unassigned: 'Unassigned',
        warning: 'The current call will be associated with this new case',
      },
      filters: {
        title: 'Filter by',
        team: 'Team',
        client: 'Client',
        agent: 'Agent',
        workflow: 'Workflow',
        step: 'Step',
      },
    },
    inProgress: { title: 'Call in progress', caseNumber: 'Case #{{caseId}}' },
  },
  supportForms: {
    list: {
      title: 'Support forms',
      subtitle: 'Support forms list',
      results: 'results',
      error: 'There was an error trying to get the support forms',
      delete: 'Confirm to delete: {{name}}',
      deleteTitle: 'Delete support form',
      deleted: 'Support form deleted',
      deleteError: 'There was an error trying to deletethe support form',
    },
    fields: {
      titleField: 'Title',
      workflowField: 'Workflow',
      descriptionField: 'Description',
      customLogoUrl: 'Custom logo URL',
      customLogoUrlHelper: "If not completed, default agency's logo will be used",
      finalUrl: 'Final url',
      name: 'Name',
      lastName: 'Last name',
      email: 'Email Address',
      emailSubject: '{{title}} {{code}} 🚀',
    },
    view: {
      titleCreate: 'Create Support Form',
      titleUpdate: 'Update Support Form',
      preview: 'Form preview',
      noWorkflows: 'No workflows found',
      saved: 'Support form saved correctly!',
      error: 'There was an error trying to save the support form',
    },
    generator: {
      title: 'Add custom fields',
      fieldType: 'Field type',
      optionsLabel: 'Options (coma separated)',
      label: 'Label',
      key: 'field name in form',
      isRequired: 'Is required',
      addField: 'Add field',
    },
    send: {
      success: 'Request successfuly sent',
      successMessage: 'We will be contacting you soon!',
      error: 'There was an error trying to send the request',
    },
    email: {
      title: 'A new case was open for: {{email}} with the following processed data:',
    },
  },
  auth: {
    login: {
      title: 'Log in to Me Vuelo',
      email: 'Email',
      password: 'Passowrd',
      forgotPassword: 'Forgot Password?',
      createAccountText: "Don't you have an account?",
      createAccountLink: 'Register',
      loginMesssage: 'Log in',
      logoutMesssage: 'Logout',
      loginGoogleMesssage: 'Login with Google',
      fieldErrorMessage: 'This field is required',
      error: 'Invalid Email or password',
    },
    forgotPassword: {
      title: 'Forgot password?',
      subtitle: "No worries, we'll send you a reset code",
      email: 'Enter your email',
      reset: 'Reset password',
      back: 'Go back',
      error: 'there was an error',
      sentEmail: 'Email sent',
    },
    resetPasswordCode: {
      title: 'Password reset',
      subtitle: 'We sent a code to',
      continue: 'Continue',
      back: 'Go back',
      error: 'There was an error',
    },
    resetPassword: {
      title: 'Set a new password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      save: 'Reset password',
      error: 'There was an error',
      success: 'Password reset success',
    },
    register: {
      title: 'Register to Me Vuelo',
      email: 'Email',
      password: 'Passowrd',
      confirm: 'Confirm passowrd',
      registerMesssage: 'Register',
      logInText: 'Already have an account?',
      logInLink: 'Log in',
      fieldErrorMessage: 'This field is required',
      userRegistered: 'User created: now log in',
      error: 'Email already exists in our database',
      errorMessage: 'Invalid Email or password!',
    },
    changePassword: {
      title: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm password',
      passwordsDontMatch: "Passwords don't match",
      changePasswordError: 'There was an error while trying change the password',
      success: 'Password successfuly changed',
      invalidPassword: 'Invalid password',
    },
    editUser: {
      title: 'Edit personal data',
      subtitle: 'Please insert data as it is shown in your identification document',
      failMessage: 'There was an error while trying to apply changes',
      uploadPicture: 'Upload image',
      pictureFieldDescription: 'Add a photo. Maximum file size 3MB',

      firstName: {
        placeHolder: 'Names',
        errorMessage: 'Required field',
        helperText: 'As it shows in you indentification document',
      },
      lastName: {
        placeHolder: 'Lastnames',
        errorMessage: 'Required field',
        helperText: 'As it shows in you indentification document',
      },
      phoneCountryCode: {
        placeHolder: 'Area code',
        errorMessage: 'Required field',
      },
      phoneNumber: {
        placeHolder: 'Phone number',
        errorMessage: 'Required field',
      },
      phoneExtension: {
        placeHolder: 'Extension number',
        errorMessage: 'This failed',
        helperText: '(optional)',
      },
      position: {
        placeHolder: 'Position',
        errorMessage: 'Required field',
      },
      address1: {
        placeHolder: 'Address',
        errorMessage: 'Required field',
        helperText: 'Ingrese su direccion',
      },
      address2: {
        placeHolder: '',
        errorMessage: 'Required field',
        helperText: '2nda linea de direccion (opcional)',
      },
      country: {
        placeHolder: 'Country',
        errorMessage: 'Required field',
      },
      city: {
        placeHolder: 'City',
        errorMessage: 'Required field',
      },
      postalCode: {
        placeHolder: 'Postal Code',
        errorMessage: 'Required field',
      },
      documentType: {
        placeHolder: 'Document type',
        errorMessage: 'Required field',
        helperText: 'Tipo de documento',
      },
      documentNumber: {
        placeHolder: 'Document number',
        errorMessage: 'Required field',
        helperText: 'As it shows in you indentification document',
      },
      profilePicture: {
        errorMessage: 'There was an error uploading your photo.',
        fileTooLarge: 'File is too large. Maximum allowed size is 3 MB.',
        invalidFileFormat: 'File format not supported.',
      },
      applyChangesBtn: 'Apply',
      patchSuccess: 'User updated successfully!',
    },
  },
  noteEditor: {
    subject: 'Subject',
    save: 'Save',
    send: 'Send',
    to: 'To',
    cc: 'CC',
    bcc: 'BCC',
    from: 'From',
    emailTitle: 'New E-mail',
    noteTitle: 'New note',
    placeholder: 'Write something',
    noOptions: 'Results not found',
    controls: {
      minimize: 'Minimize',
      maximize: 'Full screen',
      close: 'Close',
      remove: 'Remove',
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      bulletList: 'Bullet list',
      attachments: 'Attachments',
      link: 'Link',
      image: 'Image',
      undo: 'Undo',
      redo: 'Redo',
    },
    errors: {
      subject: 'Subject is required',
      content: 'Content is required',
      email: 'Recipient is required',
      fileTooLarge: 'File is too large. Maximum allowed size is 3 MB.',
      fileNotAvailable: 'No file available',
    },
  },
  customFields: {
    title: 'Custom Fields',
    subtitle: 'Custom Fields list',
    fieldBlockCreate: {
      title: 'Create Field Block',
      name: 'Name',
      createdSuccess: 'Field block created',
      createdError: 'There was an error while creating the Field block',
    },
    fieldBlockEdit: {
      title: 'Edit Field Block',
      name: 'Name',
      editSuccess: 'Field block updated',
      editError: 'There was an error while updateing the Field block',
    },
  },
  common: {
    all: 'All',
    hours: 'hours',
    view: 'View',
    create: 'Create',
    delete: 'Delete',
    deleting: 'Deleting...',
    active: 'Active',
    inactive: 'Inactive',
    mode: 'Mode',
    count: 'Count',
    name: 'Name',
    noData: 'No data available',
    comingSoon: 'Coming soon',
    mandatoryField: 'This field is mandatory',
    invalidDate: 'Invalid date',
    add: 'Add',
    close: 'Close',
    update: 'Update',
    continue: 'Continue',
    cheapest: 'Cheapest',
    nonEconomic: 'Non enconomic',
    recomended: 'recommended',
    orderBy: 'Order by:',
    results: 'Results',
    refresh: 'Refresh',
    refreshData: 'Refresh data',
    status: 'Status',
    step: 'Step',
    workflow: 'Workflow',
    channel: 'Channel',
    agent: 'Agent',
    updated: 'Updated',
    list: 'List',
    accept: 'Accept',
    confirmAction: 'Confirm Action',
    goBack: 'Go Back',
    warning: 'Warning',
    save: 'Save',
    today: 'Today',
    confirm: 'Confirm',
    cancel: 'Cancel',
    unassigned: 'Unassigned',
    yes: 'Yes',
    no: 'No',
    welcomeMessage: 'Hello world! this is an english welcome message for: ',
    filters: 'Filters',
    general: 'General',
    notValueFound: '-',
    na: 'N/A',
    new: 'New',
    search: 'Search',
    takeALook: 'Take a look',
    selectFile: 'Select file',
    tbd: 'TBD',
    maxSelectionsReached: 'Maximum selections reached',
    itemsSelected: 'items selected',
    currencies: {
      usd: 'USD',
    },
    actions: {
      add: 'Add',
      close: 'Close',
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
      gptGeneration: 'Generate with GPT',
      gptAllGeneration: 'Generate all with GPT',
      open: 'Open',
      remove: 'Remove',
      send: 'Send',
      download: 'Download',
      edit: 'Edit',
    },
    form: {
      onlyLetters: 'Only letters',
      onlyNumbers: 'Only numbers',
      onlyLettersAndNumbers: 'Only letters and numbers',
      pressEnterToAdd: 'Press enter to add',
      invalidMail: 'Invalid email',
      duplicateMail: 'Email already added',
      apply: 'Apply',
      clear: 'Clear',
      required: 'This field is required',
      save: 'Save',
      discard: 'Discard',
      select: 'Select',
      delete: 'Delete',
      url: 'This filed is an URL',
    },
    nav: {
      flights: 'Flights',
      hotels: 'Hotels',
      cars: 'Cars',
      explorer: 'Explorer',
      dashboard: 'Dashboard',
      cases: 'Cases',
      clients: 'Clients',
      saleOrders: 'Sale Orders',
      agencies: 'Agencies',
      teams: 'Teams',
      workflows: 'Workflows',
      whatsapp: 'Whatsapp',
      calls: 'Calls',
      users: 'Users',
      flightIntegrations: 'Flights',
      hotelIntegrations: 'Hotels',
      hotelContentManagement: 'Hotel Content',
      userMenu: {
        userIdentifier: 'Guest',
        myFavorites: 'My favorites',
        myNotifications: 'Notifications',
        myBookings: 'My Bookings',
        admin: 'Admin',
        routingRules: 'Routing Rules',
        markupRules: 'Markup Rules',
        userList: 'User list',
        contentManager: 'Content Manager',
        accountMessage: 'Account',
        currentCurrency: 'Currency',
        currentLanguage: 'Language',
        help: 'Help',
        selectedLanguage: 'English',
      },
    },
    footer: {
      companyType: 'Registered travel agency',
      identity: 'Real Consulting S.A. Resolution Registur N° 1263/2019',
      contactMessage: 'Contact Us',
      company: {
        title: 'Company',
        about: 'About Us',
        terms: 'Terms and Conditions',
        privacy: 'Privacy Policy',
        join: 'Join The team',
      },
      account: {
        title: 'Account',
        data: 'My Data',
        favorites: 'My Favorites',
        alerts: 'My Alerts',
        bookings: 'My Bookings',
        close: 'Log Out',
      },
      platform: {
        title: 'Platform',
        currency: 'Currency',
        language: 'Language',
        rates: 'Rates Tracker',
        rules: 'Markup Rules',
        travelers: 'My Travelers',
        airlines: 'ABM Airlines',
        cabines: 'ABM Cabins',
        alliances: 'ABM Alliances',
      },
      payments: {
        certification: {
          title: 'Safety certification',
          description: 'Mevuelo.com is certified by the council of security norms for your means of payment.',
        },
        intelligentTravel: {
          title: 'Travel smart and spend less',
          description:
            'Discover unbeatable prices on flights, hotels and cars, making every trip an economic adventure.',
        },
        explore: {
          title: 'Explore More, Worry Less',
          description:
            'With Mevuelo, traveling is easier than ever. Customize your trip as you wish, pack your dreams, and we take care of the rest.',
        },
        paymentMethods: {
          title: 'Pay with the method you like the most',
          credit: 'Credit Cards',
          bankTransfers: 'Bank Transfers',
          cash: 'Cash at any of our branches',
        },
        altImages: {
          visa: 'Visa card logo',
          oca: 'OCA card logo',
          mastercard: 'Mastercard card logo',
          american: 'American card logo',
          securityEncryption: 'Safety box image',
          wallet: 'Wallet image',
          backpack: 'Backpack image',
          card: 'Card icon',
          bank: 'Bank icon',
          cash: 'Money icon',
        },
      },
      help: {
        title: 'Help',
        faq: "FAQ's",
      },
    },
    priceTrend: {
      message: 'Price trend',
    },
    tableList: {
      numberOfResults: '{{count}} Results',
      rowsPerPage: 'Rows per page:',
      empty: 'Opss.. No results were found',
    },
    fields: {
      country: 'Country',
      provider: 'Provider',
      status: 'Status',
      actions: 'Actions',
      uploadFile: 'Upload file',
    },
    language: {
      english: 'English',
      portuguese: 'Portuguese',
      spanish: 'Spanish',
    },
    error: {
      server: 'Ops! Something went wrong! :(',
      client: 'Ops! The requested action couldn`t be sent',
      unathorized: 'Unable to verify your credentials',
      documentNotSupported: 'The file type is not supported',
    },
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'General description',
    casesByChannel: 'Cases by channel',
    casesByDay: 'Cases by day',
    casesByHourAndChannel: 'Cases by hour and channel',
    casesNeedAgentByTime: 'Cases need agent by time',
    missingAgent: 'Needs agent',
    todayCases: 'Today cases',
    connectedAgents: 'Connected agents',
    sections: {
      importantNumbers: 'Important Numbers',
      needsAgent: 'Needs Agent',
      needAgentByTeam: 'Cases that need agent by team',
      needAgentByChannel: 'Cases that need agent by channel',
      noDataAvailable: 'No data available',
      quickComparisons: 'Quick Comparisons',
      agentsStatus: 'Agents Status',
      activityTrends: 'Activity Trends',
    },
    kpis: {
      availableAgents: 'Available agents',
      needAgentCases: 'Need agent cases',
      callsOnHold: 'Calls on hold',
      avgEmailResponse: 'Avg Email response',
      avgWhatsappResponse: 'Avg WhatsApp response',
      noData: '-',
    },
    charts: {
      unassignedCasesByTeam: 'Unassigned cases by team',
      avgResponseByChannel: 'Average response by channel (minutes)',
      casesByHourPattern: 'Average cases opened by hour on {{day}}',
      casesByWeekday: 'Average cases opened by day of week',
    },
    comparatives: {
      casesResolved: 'Cases Resolved',
      casesCreated: 'Cases Created',
      whatsappConversations: 'WhatsApp Conversations',
      incomingCalls: 'Incoming Calls',
      todayVsYesterday: 'Today vs Yesterday',
      thisWeekVsPrevious: 'This week vs previous',
      vs: 'vs',
      casesNeedingAgent: 'Cases needing agent by time',
      timeRanges: {
        '0-1': '1 hour or less',
        '1-3': '1-3 hours',
        '3-8': '3-8 hours',
        '8-24': '8-24 hours',
        '24-48': '24-48 hours',
        '+48': 'More than 48 hours',
      },
    },
    agentsStatus: {
      agentStates: 'Agent States',
      agentsList: 'Agents List',
      totalAgents: 'Total Agents',
      updatedAgo: 'Updated {{time}} ago',
      noAgentsConnected: 'No agents connected',
    },
    trends: {
      weekday: 'Day of the week',
      startDate: 'Start date',
      endDate: 'End date',
      weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
      weekdaysShort: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
    },
    channels: {
      whatsapp: 'Whatsapp',
      call: 'Call',
      email: 'Email',
      externalIntegration: 'External integration',
      manual: 'Manual',
      uploaded: 'Uploaded',
      supportForm: 'Support form',
    },
    filters: {
      agencies: 'Agencies',
      teams: 'Teams',
      channels: 'Channels',
      agency: 'Select agency',
      agencyPlaceholder: 'All agencies',
      startDate: 'Start date',
      endDate: 'End date',
      withoutTeam: 'Without team',
    },
  },
  flights: {
    searcher: {
      ariaLabelSearcher: 'Flights engine',
      oneWay: 'One way',
      roundTrip: 'Round trip',
      multidestination: 'Multidestino',
      origin: 'Origin',
      departureDate: 'Departure date',
      arrivalDate: 'Arrival date',
      destination: 'Destination',
      go: 'Go',
      return: 'Return',
      unknownDates: 'I have not yet decided on the dates',
      economic: 'Economic',
      guest: 'Guests',
      search: 'Search',
      addSection: 'Add segment',
      section: 'Section {{amount}}',
    },
    availabilityLayout: {
      editSearchTitle: 'Edit Search',
      avatarAriaLabel: 'Hotel bed avatar icon',
      viewMapAriaLabel: 'Open View map button',
      tuneFiltersAriaLabel: 'Open tune filters button',
      result_one: 'result',
      result_other: 'results',
      viewMap: 'View map',
      loadingFlightsLegend: 'We are looking for the best flight deals for you.',
      loadingMoreFlights: 'Loading more flights...',
      flightDetail: 'Flight detail',
      isReturn: 'return',
      isStart: 'takeoff',
      totalDuration: 'Total duration',
      noFareDataAvailable: 'No fare data available',
      noFares: 'No fares found matching your search criteria',
    },
    cardPackage: {
      direct: 'Direct',
      doubleBaseText: 'Value per person on a double basis',
      fromText: 'From',
      reserveButtonText: 'Book',
      night_one: 'night',
      night_other: 'nights',
      stop_one: 'Stop',
      stop_other: 'Stops',
    },
    availabilityCard: {
      recommendedLabel: 'Recommended',
    },
    booking: {
      purchaseDetails: 'Purchase details',
      total: 'total',
      continueBooking: 'continue',
    },
    payment: {
      summary: 'Payment summary',
      total: 'Total payment',
      success: 'Successful payment!',
      failed: 'Unsusscessful payment',
      method: 'Payment method',
      yours: 'Your payment',
      serviceFare: 'Service fare',
      taxes: 'Taxes',
      date: 'Payment date',
    },
    voucher: {
      index: 'Voucher',
      card: 'Embarkment card',
      localizer: 'Booking localizer',
      agency: 'Agency',
      sits: 'Sits',
      gohome: 'back to home',
      gate: 'Gate',
      terminal: 'Terminal',
      arrival: 'Arrival',
      departure: 'Departure',
    },
  },
  bookings: {
    view: {
      title: 'Booking',
      subtitle: 'Booking information',
      bookingNumber: 'Reservation #',
      cancelBooking: 'Cancel',
      issueBooking: 'Issue Booking',
      caseNumber: 'Case# #',
      quotationNumber: 'Quotation #',
      salesOrderNumber: 'Salesorder #',
      created: 'Creation date',
      passengers: 'Passengers',
      name: 'FIRST NAMES',
      lastname: 'LAST NAMES',
      document: 'DOCUMENT',
      paxType: 'PAX TYPES',
      nightsIn: 'nights in',
      finalPrice: 'Final price',
    },
    title: 'Bookings',
    subtitle: 'Booking list',
    table: {
      holder: 'Holder',
      paxQty: 'Passengers',
      destination: 'Destination',
      fareProvider: 'Fare provider',
      serviceProvider: 'Service Provider',
      status: 'Status',
      reservationCode: 'Reservation',
    },
    status: {
      open: 'open',
      pending: 'pending',
      failed: 'failed',
      confirmed: 'confirmed',
      completed: 'completed',
      cancelled: 'cancelled',
      not_found: 'not found',
      expired: 'expired',
      unknown: 'unknown',
    },
  },
  hotels: {
    fareBreakDown: {
      title: 'Fare Breakdown',
      netAmount: 'Net Amount',
      grossAmount: 'Gross Amount',
      included: 'included',
      excluded: 'to be paid at hotel',
      markup: 'Markup',
      fixed: 'fixed',
      total: 'Total',
    },
    rating: {
      opinion_one: '({{formattedCount}} opinion)',
      opinion_other: '({{formattedCount}} opinions)',
      error: 'An error happened retrieving the rating of hotel. Contact site administrator',
    },
    cancelPolicyModal: {
      title: 'Cancellation Policy',
      refundableFare: 'Refundable Fare',
      penaltyNights: 'penalty night(s)',
      fromTotal: '% of the total',
      fixedAmount: 'Fixed amount',
      unknownPenalty: 'Unknown penalty',
      limitDate: 'Apply from',
      penaltyTitle: 'Cancellation Penalty',
      additionalDetails: 'Additional details',
      dateCaluclatedByProvider: 'Date origin calculated by provider',
      dateCaluclatedBySystem: 'Date origin calculated by system',
    },
    availability: {
      fareCount: 'Up to {{count}} results',
      noMarkup: 'Raw price',
      loading: 'Loading results..',
      empty: 'Oops, no results were found. Please try again in a few minutes.',
      error: 'Oops, something went worong. Please try again in a few minutes.',
    },
    fares: {
      filters: {
        searchByName: 'Search by name',
        board: 'Board',
        provider: 'Provider',
        onlyRefundable: 'Only refundable',
      },
      amenitites: 'Amenities',
      showAllAmenitiesTrue: 'Show all amenities',
      showAllAmenitiesFalse: 'Hide all amenities',
      showCompleteDescriptionTrue: 'See more',
      showCompleteDescriptionFalse: 'Hide description',
      about: 'About this hotel',
      rooms: 'Select your option',
      summary: 'Summary',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkMinAge: 'Min age for check-in/check-out',
      checkInstructions: 'Instructions for check-in/check-out',
      remarks: 'Remarks',
      paymentType: {
        MERCHANT: 'Payment is managed by the supplier.',
        DIRECT:
          'Payment is made directly to the actual payee (e.g., the hotel), without involving an intermediary or third party. The payment will be completed at check-in.',
        CARD_BOOKING: 'Payment is managed by the supplier. The payment is effectuated at the time of booking',
        CARD_CHECK_IN: 'Payment is managed by the supplier and is made at the hotel during check-in',
      },
      paxes: {
        title: 'Room for:',
        adult: 'One adult ({{age}} yrs)',
        children: 'One children ({{age}} yrs)',
      },
      room: {
        title: 'Room: ',
      },
      detail: {
        price: 'Price: ',
        refundable: 'Refundable: ',
        paymentType: 'Payment type: ',
      },
      hotelPaxData: {
        pax: {
          addInfo: 'Add passengers info',
          useExisting: 'Use existing passenger',
        },
        name: {
          title: 'First Name',
          required: 'First name is required.',
        },
        surname: {
          title: 'Last Name',
          required: 'Last name is required.',
        },
        lastName: {
          title: 'Last Name',
          required: 'Last name is required.',
        },
        birthDate: {
          title: 'Date of Birth',
          required: 'Date of birth is required.',
          notValid: 'Please enter a valid date of birth.',
          notPast: 'Date of birth cannot be in the future.',
        },
        email: {
          title: 'Email',
          notValid: 'Please enter a valid email address.',
        },
        phone: {
          title: 'Phone',
        },
        form: {
          age_one: '{{count}} year',
          age_other: '{{count}} years',
          index: 'Passenger: {{count}}',
        },
      },
      cancelPolicy: {
        title: 'Cancel policies',
        details: 'See details',
        deadline: 'Free cancelation until',
        refundable: 'Refundable',
        nonRefundable: 'Not refundable',
      },
      rateRules: {
        title: 'Rate rules:',
        values: {
          NORMAL: 'Normal',
          PACKAGE: 'Package',
          OLDER55: 'Seniors 55+',
          OLDER60: 'Seniors 60+',
          OLDER65: 'Seniors 65+',
          CANARY_RESIDENT: 'Canary resident',
          BALEARIC_RESIDENT: 'Balearic resident',
          LARGE_FAMILY: 'Large family',
          HONEYMOON: 'Honeymoon',
          PUBLIC_SERVANT: 'Public servant',
          UNEMPLOYED: 'Unemployed',
          NON_REFUNDABLE: 'Non-refundable',
          MOBILE: 'Mobile',
          WARRANTY: 'Warranty',
          ESSENTIAL_WORKER: 'Essential worker',
          NEGOTIATED: 'Negotiated',
        },
      },
    },
    searcher: {
      title: 'Hotel search',
      destination: 'Destination',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      unknownDates: 'I have not yet decided on the dates',
      room: 'Rooms',
      guest: 'Guests',
      search: 'Search',
      apply: 'apply',
      hotels: 'Hotels',
      locations: 'Locations',
    },
    roomMenu: {
      roomAmount: 'Amount',
      room: 'Room',
      year: 'year',
      years: 'years',
      adults: 'Adults',
      minors: 'Minors',
      apply: 'Apply',
      selected: '{{count}} room selected',
      selected_other: '{{count}} rooms selected',
      minorAge: 'Minor {{index}} age',
      adultAge: 'Adult {{index}} age',
      yearsOld: '{{count}} year old',
      yearsOld_other: '{{count}} years old',
      lessThanOneYear: 'Less than one year',
      error: 'Please review that all the fields are correctly completed',
    },
    cardsDestination: {
      seeMore: 'See more',
      from: 'From',
    },
    cardPackage: {
      doubleBaseText: 'Value per person on a double basis',
      fromText: 'From',
      reserveButtonText: 'Book',
      hotelRating: 'Hotel {{stars}} stars',
      nightsOfDuration: '{{amount}} nights',
    },
    filter: {
      filters: 'Filters',
      orderByAriaLabel: 'Order by sort group',
      orderBy: 'Order by',
      recommended: 'Recommended',
      bestPrice: 'Best Price',
      moreReviews: 'More Reviews',
      score: 'Score',
      name: 'Name',
      searchDistanceAriaLabel: 'Search distance slider',
      searchDistance: 'Search distance',
      radiusMessage: 'In a radius of',
      popularFiltersAriaLabel: 'Popular filters group',
      popularFilters: 'Popular filters',
      allInclusive: 'All inclusive',
      oceanView: 'Ocean view',
      hotelResort: 'Hotel resort',
      hotel: 'Hotel',
      freeCancel: 'Free cancel',
      noPaymentInAdvance: 'No payment in advance',
      priceAriaLabel: 'Prices ranges slider',
      price: 'Price',
      travelersExperienceAriaLabel: 'Travelers experience filter group',
      travelersExperience: 'Travelers experience',
      lgbtq: 'LGBTQ',
      businessFriendly: 'Business friendly',
      reducedMobility: 'Reduced Mobility',
      onlyAdults: 'Only adults',
    },
    availabilityLayout: {
      editSearchTitle: 'Edit Search',
      avatarAriaLabel: 'Hotel bed avatar icon',
      viewMapAriaLabel: 'Open View map button',
      tuneFiltersAriaLabel: 'Open tune filters button',
      results: 'results',
      viewMap: 'View map',
    },
    availabilityCard: {
      opinions: '{{numberOfOpinions}} opinions',
      endValueText: 'Total final value from',
      hotelRating: '{{rating}} star hotel',
      allInclusiveLabel: 'All inclusive',
      recommendedLabel: 'Recommended',
    },
    markupRules: {
      title: 'Markup Rules',
      optionFlights: 'Flights',
      optionHotels: 'Hotels',
      optionExplorer: 'Explorer',
      buttonNewRule: '+ NEW RULE',
      buttonBackHome: 'Back home',
      shownElements: 'Elements shown',
      listTitle: 'List of rules',
      search: 'Search engine',
    },
    routingRules: {
      title: 'Routing Rules',
      optionFlights: 'Flights',
      optionHotels: 'Hotels',
      optionExplorer: 'Explorer',
      buttonNewRule: '+ NEW RULE',
      buttonBackHome: 'Back home',
      shownElements: 'Elements shown',
      listTitle: 'List of rules',
      search: 'Search engine',
    },
    propertyMapDrawer: {
      hotelDetails: 'Hotel details',
      value: 'Final value from',
      reserveButton: 'Reserve',
    },
    propertyMapCard: {
      details: 'Details',
      opinions: 'Opinions',
      reserveButton: 'Reserve',
      popularAmenities: 'Popular amenities',
    },
    contentManager: {
      title: 'Hotels',
      subtitle: 'Hotel list',
      search: 'Search hotels..',
      error: 'An error happened retrieving hotels. Contact site administrator',
      status: {
        managed: 'Reviewed',
        outdated: 'Outdated',
        toReview: 'To Review',
      },
      fields: {
        id: 'Hotel ID',
        idSub: 'Internal ID: {{id}}',
        code: 'TGX ID',
        accessCode: 'Provider',
        name: 'Name',
        country: 'Country',
        city: 'City',
        address: 'Address',
        impressions: '# Impressions',
        status: 'Status',
        linked: 'Linked',
        modParent: 'Parent ID',
        modParentName: 'Parent Name',
        priority: 'Priority',
      },
      filters: {
        status: {
          managed: 'Managed',
          outdated: 'Outdated',
          toReview: 'To Review',
        },
        name: {
          title: 'Name',
        },
        address: {
          title: 'Address',
        },
        city: {
          title: 'City',
        },
        code: {
          title: 'TGX ID',
        },
        hotelId: {
          title: 'Hotel ID',
        },
        modParentId: {
          title: 'Internal ID',
        },
      },
      configuration: {
        title: 'Configuration',
        tabs: {
          providers: {
            title: 'Providers',
          },
          imageTags: {
            title: 'Image tags',
          },
          updates: {
            title: 'Updates',
          },
          amenities: {
            title: 'Amenities',
            subTitle: 'List of available icons for amenities',
            translatedTo: 'Translated to current locale',
          },
          categories: {
            title: 'Categories',
            subTitle: 'List of available category names',
            translatedTo: 'Translated to current locale',
          },
          amenitiesMapping: {
            title: 'Amenities mapping',
            subTitle: 'Select a provider and map the amenitites',
            notMapped: 'No amenities mapped yet',
            mapped: 'Amenity mapped succesfully',
          },
          categoriesMapping: {
            title: 'Categories mapping',
            subTitle: 'Select a provider and map the categories',
            notMapped: 'No categories mapped yet',
            mapped: 'Category mapped succesfully',
          },
        },
        defaultValues: {
          description: 'Description default',
          location: 'Location default',
          rooms: 'Rooms default',
          images: 'Images default',
          amenities: 'Amenities default',
          updateSuccess: 'Default value updated successfuly',
          updateError: 'An error happened updating default values',
          getError: 'An error happened retrieving default values',
        },
      },
      detail: {
        title: 'Hotel overview',
        error: {
          detail: 'An error happened retrieving the selected hotel. Contact site administrator',
          detailInfo: 'An error happened retrieving the selected hotel information. Contact site administrator',
        },
        description: {
          tab: 'Hotel',
          title: 'My description',
          editor: {
            name: {
              required: 'Hotel name is required',
            },
            rating: {
              required: 'Star rating is required',
            },
            descriptions: {
              required: 'Description is required',
              card: 'Card description',
              detail: 'Detail Description',
            },
            generateByAI: 'Do you want to generate descriptions by AI?',
          },
          update: {
            success: 'Descriptions updated successfully',
            error: 'An error happened updating descriptions. Contact site administrator',
          },
        },
        checkOptions: {
          tab: 'Check In / Out',
          title: 'Check In / Check Out',
          editor: {
            addOptions: 'Add',
            type: {
              title: 'Type',
              checkIn: 'Check In',
              checkOut: 'Check Out',
            },
            minAge: {
              title: 'Minimum age',
              required: 'Minimum age is required',
              error: 'Invalid age.',
              value: '{{value}} yrs old',
            },
            startTime: {
              title: 'Start time',
              required: 'Start time is required',
              error: 'Invalid start time.',
              value: '{{value}} hs',
            },
            endTime: {
              title: 'End time',
              required: 'End time is required',
              value: '{{value}} hs',
            },
            instructions: {
              title: 'Instructions',
              isSpecial: 'Is special?',
              text: 'Text',
              language: 'Language',
              edit: 'Edit instruction',
            },
          },
          update: {
            success: 'Check In / Out updated successfuly',
            error: 'An error happened updating Check In / Out options. Contact site administrator',
          },
        },
        location: {
          tab: 'Location',
          title: 'My location',
          showInMap: 'Use location',
          editor: {
            latLong: {
              required: 'Latitude and longitude are required',
              error: 'Invalid latitude, longitude format',
            },
          },
          update: {
            success: 'Location updated successfuly',
            error: 'An error happened updating location. Contact site administrator',
          },
        },
        rooms: {
          tab: 'Rooms',
          title: 'My rooms',
          subTitle: 'Room {{code}}',
        },
        images: {
          tab: 'Images',
          title: 'Hotel Images',
          tags: 'Room Tags',
          update: {
            success: 'Images updated successfully',
            error: 'An error happened updating imgaes. Contact site administrator',
          },
        },
        amenities: {
          tab: 'Amenitites',
          title: 'Hotel Amenitites',
          update: {
            success: 'Amenitites updated successfully',
            error: 'An error happened updating amenitites. Contact site administrator',
          },
        },
        category: {
          tab: 'Categories',
          mapped: 'Category mapped succesfully',
        },
        moderation: {
          link: {
            title: 'Linked hotels',
            manually: 'Link manually',
            button: 'Link',
            success: 'Hotel linked successfuly',
            error: 'An error happened linking hotels. Contact site administrator',
          },
          unlink: {
            button: 'Unlink',
            success: 'Hotel unlinked successfuly',
            error: 'An error happened unlinking hotels. Contact site administrator',
          },
          moderate: {
            button: "Mark as '{{status}}'",
            success: "Hotel marked as '{{status}}' successfuly",
            error: "An error happened marking hotel as '{{status}}'. Contact site administrator",
          },
          linked: {
            title: 'Linked',
          },
        },
        priority: {
          label: 'Priority',
          success: 'Priority updated to {{priority}}',
          error: 'An error occurred updating the priority',
        },
      },
    },
    amenities: {
      LGBTQ: 'LGBTQ',
      ac: 'Air Conditioning',
      allInclusive: 'All-Inclusive',
      aquaGym: 'Aqua Gym',
      arte: 'Art',
      azafata: 'Flight Attendant',
      babyFriendly: 'Baby-Friendly',
      badminton: 'Badminton',
      bakery: 'Bakery',
      barDeTragos: 'Cocktail Bar',
      basketball: 'Basketball',
      beach: 'Beach',
      beerPaint: 'Brewery',
      bicycle: 'Bicycles',
      billar: 'Billiards Table',
      botSail: 'Sailing',
      breakfast: 'Breakfast Included',
      brillos: 'Fireworks',
      brunch: 'Brunch',
      carRental: 'Car Rental',
      cardFill: 'Credit Card',
      casino: 'Casino',
      chefCocina: 'Chef',
      childCare: 'Childcare',
      cleaningService: 'Cleaning Service',
      closet: 'Closet',
      concierge: 'Concierge',
      conferenceRoom: 'Conference Room',
      currencyExchange: 'Currency Exchange',
      deck: 'Deck',
      desfibrilator: 'Defibrillator',
      doctor: 'Doctor',
      dryCleaning: 'Dry Cleaning',
      dryer: 'Dryer',
      eGames: 'eGames',
      ecoFriendly: 'Eco-Friendly',
      edificio: 'Building',
      elevator: 'Elevator',
      entertainment: 'Entertainment',
      family: 'Family-Friendly',
      fireplace: 'Fireplace',
      girlGym: "Women's Gym",
      golf: 'Golf',
      grillBbc: 'Barbecue',
      gym: 'Gym',
      hairSaloon: 'Hair Salon',
      jacuzzi: 'Jacuzzi',
      laundry: 'Laundry',
      library: 'Library',
      luggageCart: 'Luggage Cart',
      meetingRoom: 'Meeting Room',
      mobileOk: 'Mobile Signal',
      moneyOff: 'Cash Payment',
      multipleCard: 'Multiple Cards Accepted',
      nightClub: 'Nightclub',
      nightLife: 'Nightlife',
      parking: 'Parking',
      petfriendly: 'Pet-Friendly',
      phone: 'Phone',
      photocamara: 'Photography',
      pingPong: 'Ping Pong',
      pool: 'Swimming Pool',
      poolTable: 'Pool Table',
      proyector: 'Projector',
      restaurant: 'Restaurant Service',
      roomService: 'Room Service',
      safeBox: 'Safe Box',
      sauna: 'Sauna',
      scubadiving: 'Scuba Diving',
      securityCam: 'Security Cameras',
      seguridad: 'Security',
      shop: 'Shop',
      smokeDetector: 'Smoke Detector',
      smokeFree: 'Smoke-Free',
      smoking: 'Smoking Area',
      solarium: 'Solarium',
      spa: 'Spa',
      sportsDeportes: 'Sports Facilities',
      starFilled: 'Star Rating',
      surf: 'Surfing',
      tennis: 'Tennis',
      transfer: 'Shuttle Service',
      tv: 'Television',
      valetParking: 'Valet Parking',
      veggie: 'Vegetarian Options',
      volley: 'Volleyball',
      volunteerActivism: 'Volunteer Activities',
      waterSki: 'Water Skiing',
      wheelChair: 'Wheelchair Accessible',
      wifi: 'WiFi',
      notMappedYet: 'Amenity not mapped yet.',
    },
    categories: {
      [HotelCategories.AGROTOURISM]: 'Agrotourism',
      [HotelCategories.ONE_STAR]: 'One Star',
      [HotelCategories.ONE_KEY]: 'One Key',
      [HotelCategories.TWO_STARS]: 'Two Stars',
      [HotelCategories.TWO_KEYS]: 'Two Keys',
      [HotelCategories.THREE_STARS]: 'Three Stars',
      [HotelCategories.THREE_KEYS]: 'Three Keys',
      [HotelCategories.FOUR_STARS]: 'Four Stars',
      [HotelCategories.FOUR_KEYS]: 'Four Keys',
      [HotelCategories.FOUR_STARS_LUXURY]: 'Four Luxury Stars',
      [HotelCategories.FIVE_STARS]: 'Five Stars',
      [HotelCategories.FIVE_KEYS]: 'Five Keys',
      [HotelCategories.FIVE_STARS_LUXURY]: 'Five Luxury Stars',
      [HotelCategories.ONE_STAR_APARTHOTEL]: 'One Star Apart Hotel',
      [HotelCategories.TWO_STARS_APARTHOTEL]: 'Two Star Apart Hotel',
      [HotelCategories.THREE_STARS_APARTHOTEL]: 'Three Star Apart Hotel',
      [HotelCategories.FOUR_STARS_APARTHOTEL]: 'Four Star Apart Hotel',
      [HotelCategories.FIVE_STARS_APARTHOTEL]: 'Five Star Apart Hotel',
      [HotelCategories.FIRST_CATEGORY_APARTMENT]: '1st Category Apartment',
      [HotelCategories.SECOND_CATEGORY_APARTMENT]: '2nd Category Apartment',
      [HotelCategories.THIRD_CATEGORY_APARTMENT]: '3rd Category Apartment',
      [HotelCategories.BED_AND_BREAKFAST]: 'Bed and Breakfast',
      [HotelCategories.THREE_STARS_BED_AND_BREAKFAST]: 'Three Stars Bed And Break Fast',
      [HotelCategories.FOUR_STARS_BED_AND_BREAKFAST]: 'Four Stars Bed And Break Fast',
      [HotelCategories.FIVE_STARS_BED_AND_BREAKFAST]: 'Five Stars Bed And Break Fast',
      [HotelCategories.BOUTIQUE]: 'Boutique',
      [HotelCategories.FIRST_CATEGORY_CAMPING]: 'First Category Camping',
      [HotelCategories.SECOND_CATEGORY_CAMPING]: 'Second Category Camping',
      [HotelCategories.GUESTHOUSE]: 'Guest House',
      [HotelCategories.ONE_AND_HALF_STARS]: 'One And Half Stars',
      [HotelCategories.SUPERIOR_TWO_STARS]: 'Superior Two Stars',
      [HotelCategories.TWO_AND_HALF_STARS]: 'Two And Half Stars',
      [HotelCategories.SUPERIOR_THREE_STARS]: 'Superior Three Stars',
      [HotelCategories.THREE_AND_HALF_STARS]: 'Three And Half Stars',
      [HotelCategories.FOUR_AND_HALF_STARS]: 'Four And Half Stars',
      [HotelCategories.FIVE_AND_HALF_STARS]: 'Five And Half Stars',
      [HotelCategories.LUXURY_HISTORIC_HOTEL]: 'Luxury Historic Hotel',
      [HotelCategories.SUPERIOR_CATEGORY_RURAL_HOTEL]: 'Superior Category Rural Hotel',
      [HotelCategories.ONE_STAR_HOSTEL]: 'One Star Hostel',
      [HotelCategories.TWO_STARS_HOSTEL]: 'Two Stars Hostel',
      [HotelCategories.THREE_STARS_HOSTEL]: 'Three Stars Hostel',
      [HotelCategories.FOUR_STARS_HOSTEL]: 'Four Stars Hostel',
      [HotelCategories.FIVE_STARS_HOSTEL]: 'Five Stars Hostel',
      [HotelCategories.ONE_STAR_RURAL_HOSTEL]: 'One Star Rural Hostel',
      [HotelCategories.TWO_STARS_RURAL_HOSTEL]: 'Two Stars Rural Hostel',
      [HotelCategories.LODGE]: 'Lodge',
      [HotelCategories.MINI_HOTEL]: 'Mini Hotel',
      [HotelCategories.PENDING_CATEGORY]: 'Pending Category',
      [HotelCategories.PENSION]: 'Guesthouse o GuestRoom',
      [HotelCategories.POUSADA]: 'Inn',
      [HotelCategories.RESIDENCE]: 'Residence',
      [HotelCategories.RESORT]: 'Resort',
      [HotelCategories.WITHOUT_OFFICIAL_CATEGORY]: 'Without Official Category',
      [HotelCategories.STANDARD]: 'Standard',
      [HotelCategories.FOUR_SUPERIOR_STARS]: 'Four Superior Stars',
      [HotelCategories.VILLA]: 'Villa',
      [HotelCategories.VACATION_TOURIST_HOMES]: 'Vacation Tourist Homes',
    },
    hotelImageTag: {
      title: 'Tags',
      subtitle: 'Available Tags',
      results: 'Results',
      search: 'Search',
      table: {
        name: 'Name',
        color: 'Color',
      },
      create: {
        createdSuccess: 'Tag created',
        createdError: 'An error ocurred while creating the tag',
        title: 'Create Tag',
        name: 'Name',
        color: 'Color',
      },
      edit: {
        createdSuccess: 'Tag updated',
        createdError: 'An error ocurred while editing the tag',
        title: 'Edit Image Tag',
        name: 'Name',
        color: 'Color',
      },
      delete: {
        success: 'Tag deleted',
        error: 'An error ocurred while deleting the tag',
        title: 'Delete tag',
        message: 'Are you sure about deleting: {{ name }}?',
      },
    },
    paymentPolicies: {
      nonAnticipate: 'No advance payment',
    },
    cancelationPolicies: {
      free: 'Free cancelation',
    },
  },
  users: {
    results: 'results',
    search: 'User search',
    create: {
      title: 'Create user',
      createdError: 'An error ocurred while creating the user',
      warning: 'This is the only time this password will be shown, make sure you save it!',
      user: 'User:',
      password: 'Password:',
      finish: 'Finish',
    },
    selector: {
      title: 'User selector',
    },
    list: {
      title: 'Users',
      subtitle: 'User list',
    },
    table: {
      name: 'Fullname',
      email: 'Email',
      agency: 'Agency',
      roles: 'Roles',
      client: 'See as client',
    },
    view: {
      teams: 'teams',
    },
  },
  clients: {
    selector: {
      title: 'Client Selector',
    },
    title: 'Clients',
    subtitle: 'Client list',
    results: 'Results',
    search: 'Search',
    table: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone #',
      agency: 'Agency',
      whatsapp: 'WhatsApp #',
      client: 'Client',
      contact: 'Contact',
      preferredAgent: 'Preferred Agent',
      organization: 'Organization',
      location: 'Location',
      created: 'Created',
    },
    filters: {
      clientName: 'Client Name',
      countries: 'Countries',
      organizations: 'Organizations',
      agencies: 'Agencies',
      preferredAgent: 'Preferred Agent',
      documentTypes: 'Document Types',
      searchClientNamePlaceholder: 'Search by first or last name',
      myClients: 'View only my clients',
    },
    view: {
      title: 'Client Information',
      agencyInfo: 'Agency Information',
      basicInfo: 'Basic Information',
      contactInfo: 'Contact Information',
      addressInfo: 'Address Information',
      documentInfo: 'Document Information',
      agency: 'Agency',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phoneCountryCode: 'Country Code',
      phoneNumber: 'Phone Number',
      whatsappNumber: 'WhatsApp Number',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal Code',
      address1: 'Address',
      address2: 'Address (line 2)',
      documentType: 'Document Type',
      documentNumber: 'Document Number',
      clientSince: 'Client since',
      basicInfoSuccess: 'Basic information updated',
      contactInfoSuccess: 'Contact information updated',
      addressInfoSuccess: 'Address information updated',
      documentInfoSuccess: 'Document information updated',
      createdError: 'There was an error updating the information',
      preferredAgent: 'Preferred Agent',
      selectPreferredAgent: 'Select preferred agent',
    },
    errors: {
      DUPLICATED_PHONE_ERROR: 'Phone number is already registered for the selected Agency',
      DUPLICATED_EMAIL_ERROR: 'Email is already registered for the selected Agency',
      DUPLICATED_WHATSAPP_ERROR: 'WhatsApp number is already registered for the selected Agency',
      MISSING_FIELDS_ERROR: 'You must provide either an email, phone or WhatsApp number',
    },
    create: {
      createdSuccess: 'Client successfully created',
      createdError: 'There was an error creating the client',
      createdErrorPhone: 'Phone number is already registered for the selected Agency',
      createdErrorEmail: 'Email is already registered for the selected Agency',
      createdErrorWhatsapp: 'WhatsApp number is already registered for the selected Agency',
      createdErrorMissingFields: 'You must provide either an email, phone or WhatsApp number',
      title: 'Create Client',
      firstName: 'First Name',
      agency: 'Agency',
      lastName: 'Last Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      phoneCountryCode: 'Country Code',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal Code',
      documentType: 'Document Type',
      documentNumber: 'Document Number',
      address1: 'Address',
      address2: 'Address (line 2)',
      whatsappNumber: 'WhatsApp',
    },
    edit: {
      whatsappNumber: 'WhatsApp',
      createdSuccess: 'Client successfully updated',
      createdError: 'There was an error updating the client',
      title: 'Update Client',
      firstName: 'First Name',
      agency: 'Agency',
      lastName: 'Last Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      phoneCountryCode: 'Country Code',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal Code',
      documentType: 'Document Type',
      documentNumber: 'Document Number',
      address1: 'Address',
      address2: 'Address (line 2)',
    },
  },
  workflows: {
    title: 'Workflows',
    subtitle: 'List of available workflows',
    results: 'Results',
    search: 'Search',
    form: {
      name: 'Name',
      color: 'Color',
      domains: 'Domains',
      domainsHint: 'You can add emails or just domains, e.g: *@acme.com or john.doe@acme.com',
      error: {
        invalidEmailDomain: 'The domain {{ emailDomainValue }} is not valid',
      },
    },
    selectedStep: {
      title: 'Step details',
      label: 'Step name',
      info: 'Step information',
      delete: 'Delete step',
      teams: 'Teams',
      mailTemplate: 'Mail template',
      isCancelStepLabel: 'Cancel step?',
      cancelStepExists: 'A cancel step already exists',
    },
    instructions: {
      title: '{{step}} instructions',
      save: 'Save',
      close: 'Close',
      tabs: {
        edit: 'Edit',
        preview: 'Preview',
      },
    },
    edit: {
      title: 'Edit Workflow',
      error: 'There was an error while editing the workflow',
      success: 'Workflow successfully updated',
      unsavedChanges: 'There are unsaved changes. Do you want to save before leaving?',
    },
    create: {
      title: 'Create Workflow',
      error: 'There was an error while creating the workflow',
      success: 'Workflow successfully created',
      step: {
        title: 'Create Step',
        color: 'Color',
        name: 'Name',
        teams: 'Teams',
      },
    },
    table: {
      name: 'Name',
      color: 'Color',
      emailDomains: 'Email Domains',
    },
    view: {
      addInitialStep: 'Add initial step',
      addMiddleStep: 'Add middle step',
      addFinalStep: 'Add final step',
      agency: 'Agency',
      color: 'Color',
      created: 'Created',
      updatedSuccess: 'Workflow successfully updated',
    },
    actions: {
      title: 'Actions',
      filters: 'Filters',
      settings: 'Settings',
      add: 'Add',
    },
  },
  agencies: {
    title: 'Agencies',
    subtitle: 'List of available agencies',
    results: 'Results',
    search: 'Search',
    view: {
      dashboard: 'Dashboard',
      generalSettings: 'General Config',
      caseHandlers: 'Case Handlers',
      supportForms: 'Support Forms',
      twilio: 'Twilio',
      teams: 'Teams',
      communications: 'Communications',
      callsMenu: 'Calls Menu',
      iaConfig: 'AI Configuration',
      whatsappSettings: 'Whatsapp Settings',
      uploads: 'Data uploads',
      organizations: 'Organizations',
      phone: 'Phone',
      email: 'Mailing',
      workflows: 'Workflows',
      general: 'General',
      settings: 'Settings',
      flights: 'Flights',
      hotels: 'Hotels',
      markupRules: 'Markup Rules',
      routingRules: 'Routing Rules',
      invalidationRules: 'Invalidation Rules',
      integrations: 'Integrations',
      customFields: 'Custom Fields',
      flightIntegrations: 'Flight Integrations',
    },
    table: {
      name: 'Name',
      currency: 'Currency',
      country: 'Country',
      isPrivate: 'Is a private site',
    },
    settings: {
      twilio: 'Twilio',
      saveSuccess: 'Settings saved',
      saveError: 'An error ocurred while saving the settings...',
      general: 'General',
      auth: 'Authentication',
      communicationChannels: 'Communication Channels',
      maps: 'Maps',
      callsMenu: 'Calls menu',
      whitelabeling: 'White labeling',
      aws: 'AWS',
      sendgrid: 'Sendgrid',
      googleMaps: 'Google Maps',
      googleSignIn: 'Google Sign-in',
      registration: 'Registration',
      whatsapp: 'Whatsapp (Gupshup)',
      emailSignature: 'Email Signature',
      openai: 'OpenAI',
      ai: 'Artificial Intelligence',
      whatsappSubscriptionError: 'Error al crear subscripcion',
      hotels: 'Hotels',
      placeholders: {
        selectAIUser: 'Select an AI user',
        noUsersFound: 'No users found',
        contextMessages: '10',
      },
      envMap: {
        AI_CASE_HANDLERS_ENABLED: 'Enable AI for case handlers',
        IA_USER_ID: 'IA User ID',
        TWILIO_ACCOUNT_SID: 'Account SID',
        TWILIO_AUTH_TOKEN: 'Authorization Token',
        TWILIO_API_KEY: 'API KEY',
        TWILIO_API_KEY_SECRET: 'Api KEY secret',
        TWILIO_TWIML_APP_SID: 'Twiml app sid',
        TWILIO_PHONE_NUMBER: 'Phone number',
        TWILIO_TRUNK_SID: 'Twilio trunk SID',
        JWT_SECRET: 'JWT secret',
        REFRESH_JWT_SECRET: 'JWT refresh token secret',
        DEFAULT_WORKFLOW_ID: 'Default workflow Id',
        WHATSAPP_DEFAULT_WORKFLOW_ID: 'Whatsapp Default workflow Id',
        JWT_RESET_PASSWORD: 'JWT reset pwd token secret',
        WHITELABEL_CODE: 'Whitelabel code',
        AWS_REGION: 'Region',
        AWS_ACCESS_KEY_ID: 'Access Key Id',
        AWS_SECRET_ACCESS_KEY: 'Secret Access Key',
        AWS_S3_ENDPOINT: 'S3 endpoint',
        AWS_S3_BUCKET_EMAIL_ATTACHMENTS: 'S3 bucket mail attachments',
        GOOGLE_CLIENT_ID: 'Client ID',
        GOOGLE_CLIENT_SECRET: 'Client Secret',
        GOOGLE_CALLBACK_URL: 'Callback URL',
        VITE_GOOGLE_KEY: 'Google Key',
        CLIENT_URL: 'Client URL',
        SENDGRID_API_KEY: 'API Key',
        SENDGRID_SENDER_EMAIL: 'Sender email',
        SENDGRID_INBOUND_MAILS: 'Managed mails',
        VITE_MAP_ID: 'Map Id',
        MAIL_CREDENTIAL: 'Mail credential',
        GUPSHUP_AUTH_SECRET: 'Auth Secret',
        GUPSHUP_AUTH_USER: 'login mail',
        GUPSHUP_APP_ID: 'Application ID',
        GUPSHUP_PARTNER_API_URL: 'Partner Api URL',
        GUPSHUP_APP_NAME: 'Application Name',
        GUPSHUP_PHONE_NUMBER: 'Phone Number',
        GUPSHUP_SENDER_NAME: 'Sender Name',
        ALLOWED_EMAIL_DOMAIN: 'Allowed email domain to access',
        VITE_MANUAL_REGISTRATION_ALLOWED: 'Manual registration allowed? (true/false)',
        WHATSAPP_OPENAI_API_KEY: 'OpenAI API Key',
        WHATSAPP_OPENAI_AMOUNT_OF_CONTEXT_MESSAGES: 'Amount of context messages for AI',
        HOTEL_BOOK_AGENCY_REFERENCE: 'Hotels booking reference prefix',
        HOTEL_BOOK_MINOR_AGE_DELIMITER: 'Determine minors age',
      },
    },
    create: {
      createdSuccess: 'Agency successfully created',
      createdError: 'There was an error while creating the agency',
      title: 'Create Agency',
      name: 'Name',
      country: 'Country',
      currency: 'Currency',
      isPrivate: 'Private site',
    },
    edit: {
      createdSuccess: 'Agency successfully updated',
      createdError: 'There was an error while updating the agency',
      title: 'Update Agency',
      name: 'Name',
      country: 'Country',
      currency: 'Currency',
      isPrivate: 'Private site',
    },
  },
  caseHandlers: {
    title: 'Case Handlers',
    subtitle: 'List of available case handlers',
    results: 'Results',
    search: 'Search',
    table: {
      name: 'Name',
      description: 'Description',
      enabled: 'Enabled',
      scanWorkflow: 'Scan Workflow',
      scanStep: 'Scan Step',
      scanStatus: 'Scan Status',
      nextWorkflow: 'Next Workflow',
      nextStep: 'Next Step',
      nextStatus: 'Next Status',
      channel: 'Channel',
    },
    create: {
      title: 'Create Case Handler',
      success: 'Handler created successfully',
      error: 'There was an error creating the handler',
    },
    edit: {
      title: 'Edit Case Handler',
      success: 'Handler updated successfully',
      error: 'There was an error updating the handler',
    },
    form: {
      name: 'Name',
      namePlaceholder: 'Enter handler name',
      description: 'Description',
      descriptionPlaceholder: 'Enter optional description',
      messageContextHistoryCount: 'Context count',
      enabled: 'Enabled',
      channel: 'Channel',
      channelPlaceholder: 'Enter channel (optional)',
      scanStatus: 'Scan Status',
      scanStatusPlaceholder: 'Enter scan status (optional)',
      nextStatus: 'Next Status',
      nextStatusPlaceholder: 'Enter next status (optional)',
      scanWorkflow: 'Scan Workflow',
      scanWorkflowPlaceholder: 'Select scan workflow',
      scanStep: 'Scan Step',
      scanStepPlaceholder: 'Select scan step',
      nextWorkflow: 'Next Workflow',
      nextWorkflowPlaceholder: 'Select next workflow',
      nextStep: 'Next Step',
      nextStepPlaceholder: 'Select next step',
      prompt: 'Prompt',
      promptPlaceholder: 'Enter handler prompt',
      listeningTo: 'Listening to',
      onSuccess: 'On Success',
      onBailout: 'On Bailout',
      onCancel: 'On Cancel',
      promptSection: 'Prompt',
      // New translations for AI Handler fields
      iaHandlerConfiguration: 'AI Handler Configuration',
      handlerPurpose: 'Handler Purpose',
      handlerPurposePlaceholder: 'Describe the specific purpose of this handler...',
      behaviorRules: 'Behavior Rules',
      behaviorRulesPlaceholder: 'Define specific behavior rules...',
      stepsDescription: 'Steps Description',
      stepsDescriptionPlaceholder: 'Describe the steps to follow...',
      examples: 'Examples',
      handlerExample: 'Result Example',
      handlerExamplePlaceholder: 'Provide an example of the expected result...',
      conversationExample: 'Conversation Example',
      conversationExamplePlaceholder: 'Show a conversation example...',
      validationsAndNotes: 'Validations and Notes',
      validations: 'Validations',
      validationsPlaceholder: 'Define required validations...',
      allowedTools: 'Allowed Tools',
      allowedToolsPlaceholder: 'Select the tools this handler can use',
      additionalNotes: 'Additional Notes',
      additionalNotesPlaceholder: 'Add any important additional notes...',
      // Tabs labels
      tabs: {
        listening: 'Listening',
        handlePurpose: 'Handle Purpose',
        behaviourRules: 'Behaviour Rules',
        steps: 'Steps',
        resultExamples: 'Result Examples',
        conversationExamples: 'Conversation Examples',
        validations: 'Validations',
        additionalNotes: 'Additional Notes',
      },
    },
  },
  teams: {
    title: 'Teams',
    subtitle: 'List of available teams',
    results: 'Results',
    search: 'Search',
    table: {
      name: 'Name',
      email: 'Email',
      agency: 'Agency',
      color: 'Color',
      isAvailableInPhone: 'is in queue',
    },
    create: {
      createdSuccess: 'Team successfully created',
      createdError: 'There was an error while creating the team',
      title: 'Create Team',
      name: 'Name',
      agency: 'Agency',
      color: 'Color',
    },
    edit: {
      createdSuccess: 'Agency successfully updated',
      createdError: 'There was an error while updating the agency',
      title: 'Update Team',
      name: 'Name',
      agency: 'Agency',
      color: 'Color',
    },
    members: 'members',
    linkUserToTeam: {
      success: 'User successfuly linked to team',
      failed: 'There was a problem while linking the user',
      removed: 'User removed from team',
      removedFailed: 'There was a problem while removing the user',
      removeToolip: 'Remove from team',
    },
  },
  organizations: {
    title: 'Organizations',
    subtitle: 'List of available organizations',
    results: 'Results',
    search: 'Search',
    table: {
      name: 'Name',
      domain: 'Domain',
      agency: 'Agency',
      memberCount: 'Member count',
    },
    create: {
      createdSuccess: 'Organization successfully created',
      createdError: 'There was an error while creating the organization',
      title: 'Create Organization',
      name: 'Name',
      domain: 'Domain',
    },
    edit: {
      createdSuccess: 'Organization successfully updated',
      createdError: 'There was an error while updating the organization',
      title: 'Update Organization',
      name: 'Name',
      domain: 'Domain',
    },
    domainError: 'Enter a valid domain (e.g. @yourdomain.com)',
    members: 'members',
    linkUserToOrganization: {
      success: 'User successfuly linked to organization',
      failed: 'There was a problem while linking the user',
      removed: 'User removed from organization',
      removedFailed: 'There was a problem while removing the user',
      removeToolip: 'Remove from organization',
    },
    selector: {
      add: 'agregar',
      title: 'Organization selector',
    },
  },
  error404: {
    message: "The page you're looking for doesn't exist.",
    btnLabel: 'back home',
  },
  error401: {
    message: 'Unauthorized access.',
    btnLabel: 'Back home',
  },
  linkCaseModal: {
    newCase: 'New case',
    linkedTo: 'Link to',
    duplicates: 'Dupes',
    linkSuccess: 'Case link successful',
    linkError: 'Unable to link case',
    selectCaseError: 'You need to select a case',
    searchTextLabel: 'Search for a case',
  },
  cases: {
    status: {
      [CaseStatus.open]: 'open',
      [CaseStatus.inProgress]: 'in progress',
      [CaseStatus.needsClientAction]: 'waiting for response',
      [CaseStatus.needsAgentAction]: 'needs agent',
      [CaseStatus.done]: 'completed',
      [CaseStatus.canceled]: 'canceled',
    },
    originatedByChannel: {
      [OriginatedByChannel.WHATSAPP]: 'WhatsApp',
      [OriginatedByChannel.CALL]: 'Call',
      [OriginatedByChannel.EMAIL]: 'Email',
      [OriginatedByChannel.MANUAL]: 'Manual',
      [OriginatedByChannel.EXTERNAL_INTEGRATION]: 'External integration',
      [OriginatedByChannel.UPLOADED]: 'Uploaded',
      [OriginatedByChannel.SUPPORT_FORM]: 'Support form',
    },
    stats: {
      byDay: 'Cases by day',
      count: 'Number of cases',
      date: 'Date',
      byTeam: 'Cases by team',
      byStatus: 'Cases by status',
      byWorkflow: 'Cases by workflow',
      noTeam: 'No team',
      noWorkflow: 'Unassigned',
    },
    statistics: {
      title: 'Case Statistics',
      byAgent: 'Cases by Agent',
      byTeam: 'Cases by Team',
      byAgency: 'Cases by Agency',
      byChannel: 'Cases by Channel',
      byStatus: 'Cases by Status',
      byWorkflow: 'Cases by Workflow',
      byStep: 'Cases by Step',
    },
    export: {
      csvButton: 'Generate CSV report (you will receive an email when ready)',
      processingMessage: 'Case report is being processed. You will receive an email when ready.',
      errorMessage: 'There was an error generating the report',
    },
    create: {
      createdSuccess: 'Case successfully created',
      createdError: 'There was an error while creating the case',
      placeholder: 'Enter new case name...',
      agency: 'Agency',
      client: 'Client',
    },
    update: {
      success: 'Case successfully updated',
      error: 'There was an error while modifying your case',
    },
    list: {
      filters: {
        title: 'Filters',
        name: 'Filter name',
        placeHolderNew: 'New Filter name',
        placeHolderExisting: 'Editar filter name',
        owner: 'Author',
        myFilters: 'My Filters',
        publicFilters: 'Public Filters',
        checkbox: 'mark as public',
        clear: 'Clear',
        save: 'Save',
        createNew: 'Add new',
        createError: 'Error while creating filter',
      },
      filterByStatus: 'Filter by status',
      filterByTeam: 'Filter by team',
      filterByWorkflow: 'Filter by workflow',
      filterByStep: 'Filter by step',
      filterByAgent: 'Filter by agent',
      filterByClient: 'Filter by client',
      filterByOrganization: 'Filter by organization',
      filterBySubject: 'Filter by subject',
      filterByOriginatedByChannel: 'Filter by origin channel',
      filterByAgency: 'Filter by agency',
      filterByCreated: 'Filter by created date',
      filterByUpdated: 'Filter by updated date',
      filterByCreatedAfter: 'Created after',
      filterByCreatedBefore: 'Created before',
      title: 'Cases',
      subtitle: 'Case list',
      search: 'Search...',
      tabs: {
        all: 'All',
        myGroups: 'My Teams',
        myCases: 'My Cases',
      },
      results: 'Results',
      table: {
        organization: 'Organization',
        client: 'Client',
        subject: 'Subject',
        agency: 'Agency',
        team: 'Team',
        workflow: 'Workflow',
        step: 'Step',
        status: 'Status',
        channel: 'Channel',
        agent: 'Agent',
        created: 'Created',
        lastUpdate: 'Last update',
      },
    },
    view: {
      assignToMe: 'Assign to me',
      case: 'Case',
      copyCaseNumber: 'Copy case number',
      copySuccess: 'Case number copied to clipboard',
      titleStatus: 'Case status',
      titleClient: 'Customer information',
      titleOtherDetails: 'Other details',
      relationRemovedSuccess: 'Case successfuly unlinked',
      relationRemovedError: 'An error occurred while unlinking the case',
      addRelationShip: 'Link to another case',
      instructions: 'Instructions',
      assignments: 'Assignments',
      workflow: 'Workflow',
      step: 'Step',
      status: 'Status',
      team: 'Team',
      organization: 'Organization',
      client: 'Client',
      agent: 'Assigned Agent',
      saleorderLegacy: 'Sales Order (Legacy)',
      saleorder: 'Sale Order',
      agency: 'Agency',
      created: 'Created',
      iaEnabled: 'AI Enabled',
      log: {
        UPDATE: 'updated',
        CREATE: 'created',
        LINKED: 'linked',
        DUPED: 'duped',
        WORKFLOW: 'Workflow',
        ORGANIZATION: 'Organization',
        AGENCY: 'Agency',
        IA_ENABLED: 'AI Enabled',
        STEP: 'Step',
        TEAM: 'Team',
        STATUS: 'Status',
        CLIENT: 'Client',
        AGENT: 'Agent',
        CASE: 'Case',
        DELETE: 'deleted',
        SALEORDER: 'Sales order',
        from: 'from',
        to: 'to',
        saleorder: {
          DELETE: 'Sale order removed',
          CREATE: 'Sale order added',
        },
      },
      content: {
        activity: 'Activity',
        show: 'Show',
        all: 'All',
        history: 'History',
        search: 'Search...',
        whatsapp: 'Whatsapp',
        voicemail: 'Voice messages',
        note: 'Notes',
        phone: 'Calls',
        email: 'Emails',
        notes: 'Notes',
        endsWithin: 'Your session ends within:',
        subject: 'Subject',
        date: 'Date',
        viewMore: 'See more',
        noteText: 'added a note',
        edit: 'Edited',
        caseEdit: 'edited the case',
        caseCreate: 'created the case',
        emailText: 'sent an email',
        phoneCallText: 'called',
        reply: 'Reply',
        replyToAll: 'Reply to all',
        from: 'From',
        to: 'To',
        cc: 'CC',
        bcc: 'BCC',
        newEmail: 'Send email',
        draft: 'Draft',
        newWhatsapp: 'Send whatsapp',
        newNotes: 'Create note',
        imagePreview: 'Image preview',
        call: 'Call',
        incomingCall: 'Incoming call',
        outgoingCall: 'Outgoing call',
        missingContactData: 'No contact data available',
        callTransfers: {
          transferredTo: 'Transferred to',
        },
        loading: 'Loading...',
        hideThread: 'Hide thread',
        showThread: 'Show previous thread',
        showThreadWithCount: 'Show previous thread ({{count}} messages)',
        previousMessages: 'Previous messages • {{count}} messages',
        noDate: 'No date',
        replySubject: 'Re',
        legacyEmailTooltip: 'Email prior to thread optimization',
        cleanedEmailTooltip: 'Quoted content detected and cleaned',
      },
      moreInfo: 'More information',
      lessInfo: 'Less information',
      tabInfo: 'Info',
      tabHistory: 'History',
    },
  },
  callsMenu: {
    [WELCOME_MESSAGE]: 'Welcome message',
    saveSuccess: 'IVR saved successfully',
    saveError: 'An error occurred while saving the IVR',
    selectedStage: {
      dialpad: 'Numbers to connect',
      timeout: 'Timeout (sec.)',
      timeoutAction: {
        label: 'If no digit is pressed',
        action: {
          [TimeoutAction.REPEAT]: 'Repeat',
          [TimeoutAction.EXIT]: 'Exit',
        },
      },
      audioRecorder: {
        title: 'Record',
        delete: 'Delete recording',
      },
      text: {
        title: 'Text',
        textPlaceholder: 'Enter the text you want to convert to voice',
      },
      file: {
        title: 'File',
        uploading: 'Uploading file...',
        delete: 'Delete file',
        upload: 'Upload file',
        uploaded: 'Audio uploaded',
        uploadSuccess: 'File uploaded successfully',
        uploadError: 'An error occurred while uploading the file',
      },
      audioPlayer: {
        play: 'Play',
        pause: 'Pause',
        delete: 'Delete audio',
      },
      sendTo: 'Send to',
      actionType: {
        [IVRActionType.ENTER_EXTENSION]: 'Extension',
        [IVRActionType.SEND_TO_QUEUE]: 'Team',
      },
      communicationType: {
        title: 'Communication type',
        types: {
          [CommunicationType.TEXT_TO_SPEECH]: 'Text to speech',
          [CommunicationType.AUDIO_RECORD]: 'Audio',
          [CommunicationType.AUDIO_FILE]: 'File',
        },
      },
      menu: {
        label: 'Menu name',
        delete: 'Delete menu',
      },
      action: {
        label: 'Action name',
        delete: 'Delete action',
      },
    },
    stage: {
      team: 'Team',
    },
  },
  notifications: {
    title: 'Notificationes',
    clean: 'Mark as read',
    recents: 'Recents',
    [NotificationType.CASE_ASSIGNED_TO_ME]: {
      title: 'Caso Assigned',
      message: 'User <b>{{username}}</b> assigned you to case <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_UNASSIGNED_ME]: {
      title: 'Caso Unassigned',
      message: 'User <b>{{username}}</b> unassigned you from case <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_STATUS_MODIFIED]: {
      title: 'Case Modified',
      message: 'User <b>{{username}}</b> change the status of <b>{{caseId}}</b> to <b>{{status}}</b>',
    },
    [NotificationType.CASE_EMAIL_ADDED]: {
      title: 'Mail sent',
      message: 'User <b>{{username}}</b> sent an email in case <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_NOTE_ADDED]: {
      title: 'Note Added',
      message: 'User <b>{{username}}</b> added a note to case <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_CLIENT_REPLIED]: {
      title: 'Client Replied',
      message: 'Client <b>{{clientName}}</b> replied to case <b>{{caseId}}</b>',
    },
  },
  markupRules: {
    newGroup: '+ NEW GROUP',
    buttonBackList: 'Back list',
    isActive: 'Active',
    deleteGroup: 'Delete group',
    addCondition: '+ Add condition',
    addAction: '+ Add action',
    relationshipGroups: 'Relationship between groups',
    and: 'AND',
    or: 'OR',
    name: 'Name',
    order: 'Order',
    markup: 'Margen',
    percentage: 'percentage',
    fee: 'fee',
    buttonDiscard: 'Discard',
    buttonSave: 'Save',
    conditionalGroup: 'Conditional group',
    createSuccess: 'Markup rule created',
    createError: 'An Error ocurred while creating the rule',
    viewEdit: {
      titleNew: 'Create markup rule',
      titleEdit: 'Edit markup rule',
      subtitleNew: 'Create markup rule',
      subtitleEdit: 'Edit markup rule',
    },
    yup: {
      nameRequired: 'The rule name is required',
      nameCharLength: 'The rule name must be 50 characters or less',
      operatorRequired: 'Operator is required',
      operatorInvalid: 'Invalid operator selected',
      fieldRequired: 'This field is required',
      fieldInvalid: 'Invalid field selected',
      valueRequired: 'Value is required',
      valueCharLength: 'Value must be 100 characters or less',
      minConditions: 'At least one condition is required',
      markupRequired: 'Markup is required',
      valueNotNegative: 'Value cannot be negative',
    },
    hotelMarkupFieldOptions: {
      [MarkupFieldOptionHotels.PAX_QTY]: 'Passenger quantity',
      [MarkupFieldOptionHotels.ROOM_QTY]: 'Room quantity',
      [MarkupFieldOptionHotels.HOTEL_VENDOR]: 'Hotel vendor',
      [MarkupFieldOptionHotels.REQUEST_DATE]: 'Request date',
      [MarkupFieldOptionHotels.TRIP_START_DATE]: 'Trip start date',
      [MarkupFieldOptionHotels.PROPERTY_NAME]: 'Property name',
      [MarkupFieldOptionHotels.DESTINATION]: 'Destination',
      [MarkupFieldOptionHotels.HAS_INFANT]: 'Has infants',
      [MarkupFieldOptionHotels.HAS_CHILD]: 'Has child',
      [MarkupFieldOptionHotels.RATE_CURRENCY]: 'Currency',
      [MarkupFieldOptionHotels.RATE_REFUNDABLE]: 'Is Refundable',
      [MarkupFieldOptionHotels.IS_CORPO]: 'Is Corpo',
      [MarkupFieldOptionHotels.CONNECTIVITY_VENDOR]: 'Connectivity Vendor',
    },
    operators: {
      [MarkupRuleOperator.EQUALS]: '=',
      [MarkupRuleOperator.NOT_EQUALS]: '!=',
      [MarkupRuleOperator.GREATER_THAN]: '>',
      [MarkupRuleOperator.GREATER_THAN_OR_EQUAL]: '>=',
      [MarkupRuleOperator.LESS_THAN]: '<',
      [MarkupRuleOperator.LESS_THAN_OR_EQUAL]: '=<',
      [MarkupRuleOperator.CONTAINS]: 'contains',
      [MarkupRuleOperator.NOT_CONTAINS]: 'does not contain',
      [MarkupRuleOperator.STARTS_WITH]: 'start with',
      [MarkupRuleOperator.ENDS_WITH]: 'ends width',
    },
  },
  cart: {
    title: 'Cart',
    summary: 'Summary',
    total: 'Total',
    checkout: 'Convert to Sale Order',
    keepBuying: 'Keep Shopping',
    cartAddItemError: 'There was an error while trying to add you item to the cart',
    hotels: 'Hotels',
    cars: 'Cars',
    flights: 'Flights',
    services: 'Services',
    convert: {
      success: 'Sale order created',
      error: 'There was an error doing converting the cart to a sale order. Please try again later',
      successMessage: 'The tracking number for your order is:',
    },
  },
  saleOrder: {
    status: {
      [SALE_ORDER_STATUS.Sold]: 'Sold',
      [SALE_ORDER_STATUS.Active]: 'Active',
      [SALE_ORDER_STATUS.Canceled]: 'Cancelled',
      [SALE_ORDER_STATUS.Lead]: 'Lead',
    },
    list: {
      title: 'Sale Orders',
      subtitle: 'List of sale orders',
      results: 'results',
      table: {
        id: '#',
        status: 'Status',
        createdBy: 'Author',
        convertedAt: 'Converted at',
        updatedAt: 'Updated at',
        case: 'Case',
        amount: {
          title: 'Amount',
          value: 'USD {{value}}',
        },
      },
    },
    view: {
      title: 'Sale Order',
      subtitle: '# {{record}}',
      sideBarTitle: 'Sale order side menu',
      passengers: {
        title: 'Passengers',
        subtitle: 'List of passengers',
        newPassenger: 'New Passenger',
        passengerData: 'Passenger Data',
        successUpdatingPax: 'Passenger information updated successfully',
        errorUpdatingPax: 'Error updating passenger information',
        table: {
          name: 'Name',
          lastname: 'Surname',
          email: 'Email',
          age: 'Age (actual)',
          dob: 'Date of Birth',
          actions: 'Actions',
        },
        form: {
          name: 'Name',
          lastName: 'Last Name',
          birthDate: 'Birth Date',
          email: 'Email',
          phone: 'Phone',
        },
      },
      hotels: {
        title: 'Hotel: {{name}}',
        detail: {
          title: 'Details',
          nights: 'Nights',
          markup: 'Markup %',
          subPrice: 'Sub price',
          totalPrice: 'Total price',
          checkIn: 'Check In',
          checkOut: 'Check Out',
          bookingId: 'Booking ID',
          supplierReference: 'Reference - {{supplierName}}',
          board: 'Board',
          cancelPolicies: 'Cancel Policies',
          remarks: 'Remarks',
          rateRules: 'Rate rules',
        },
        cancel: 'Cancel',
        cancelled: 'Cancelled',
        cancelSuccess: 'Booking canceled successfuly',
        emit: 'Emit',
        emitSuccess: 'Booking emitted successfuly',
        emitError: 'There was an error while emitting the booking',
        holder: {
          title: 'Holder data',
          name: 'Name',
          lastname: 'Surname',
          email: 'Email',
        },
      },
      rooms: {
        title: 'Rooms ({{rooms}})',
        paxName: 'Name',
        paxAge: 'Age (at time of check-out)',
      },
    },
    link: {
      action: {
        add: 'Link sale order',
      },
      modal: {
        action: 'Link',
        title: 'Link to Case',
        searchPlaceholder: 'Search by order number...',
        loadError: 'Error loading sale orders',
      },
      list: {
        title: 'Sale Orders',
        linkButton: 'Link Order',
        createdBy: 'Created by',
        amount: 'Amount',
        name: 'Name',
        unlinkConfirm: {
          title: 'Confirm Unlink',
          message: 'Are you sure you want to unlink this order?',
          cancel: 'Cancel',
          confirm: 'Unlink',
        },
      },
      notifications: {
        linkSuccess: 'Sale order linked successfully',
        linkError: 'Error linking sale order',
        unlinkSuccess: 'Sale order unlinked successfully',
        unlinkError: 'Error unlinking sale order',
        loadError: 'Error loading sale orders',
      },
    },
    unlink: {
      modal: {
        title: 'Confirm Unlink',
        message: 'Are you sure you want to unlink this order?',
        cancel: 'Cancel',
        confirm: 'Unlink',
      },
      notifications: {
        unlinkSuccess: 'Sale order unlinked successfully',
        unlinkError: 'Error unlinking sale order',
      },
    },
    bookingDetails: {
      title: 'Provider details',
      hotelName: 'Provider hotel name',
      provider: 'Provider name',
      reference: 'Provider booking reference',
    },
  },
  invalidationRules: {
    name: 'Name',
    expireAfter: 'Expire after',
    isActive: 'Active',
    title: 'Invalidation Rules',
    subtitle: 'List of Invalidation Rules',
    results: 'Results',
    search: 'Search',
    minutes: 'Minutes',
    serviceType: {
      hotels: 'Hotels',
    },
    table: {
      order: 'Order',
      isDefault: 'Default',
      serviceType: 'Service type',
      yes: 'Yes',
      no: 'No',
      lastUpdate: 'Last update',
      created: 'Created',
      updatedBy: 'Updated by',
      createdBy: 'Created by',
    },
    validations: {
      nameCharLength: 'The rule name must be 255 characters or less',
      fieldRequired: 'This field is required',
      expireAfterMin: 'Expire after must be greater than or equal to 0',
      expireAfterMustBeNumber: 'Expire after must be a number',
      operatorInvalid: 'Invalid operator selected',
      fieldInvalid: 'Invalid field selected',
      valueRequired: 'Value is required',
      valueCharLength: 'Value must be 255 characters or less',
      minConditions: 'At least one condition is required',
      valueInvalidDate: 'Invalid date, value must be in format YYYY-MM-DD',
    },
    viewEdit: {
      titleNew: 'Create invalidation rule',
      titleEdit: 'Edit invalidation rule',
      subtitleNew: 'Create invalidation rule',
      subtitleEdit: 'Edit invalidation rule',
      deleteGroup: 'Delete group',
      addCondition: '+ Add condition',
      addAction: '+ Add action',
      createSuccess: 'Invalidation rule created',
      createError: 'An Error occurred while creating the invalidation rule',
      updateSuccess: 'Invalidation rule updated',
      updateError: 'An Error occurred while updating the invalidation rule',
      buttonDiscard: 'Discard',
      conditions: 'Conditions',
      field: 'Field',
      operator: 'Operator',
      value: 'Value',
    },
    fieldOptions: {
      [InvalidationRuleFieldOptionHotels.SUPPLIER_ACCESS_CODE]: 'Supplier access code',
      [InvalidationRuleFieldOptionHotels.CHECK_IN_DATE]: 'Checkin date',
      [InvalidationRuleFieldOptionHotels.CHECK_OUT_DATE]: 'Checkout date',
    },
    operatorOptions: {
      [InvalidationRuleOperator.EQUALS]: '=',
      [InvalidationRuleOperator.NOT_EQUALS]: '!=',
      [InvalidationRuleOperator.GREATER_THAN]: '>',
      [InvalidationRuleOperator.GREATER_THAN_OR_EQUAL]: '>=',
      [InvalidationRuleOperator.LESS_THAN]: '<',
      [InvalidationRuleOperator.LESS_THAN_OR_EQUAL]: '=<',
    },
  },
  dataUploads: {
    title: 'Data Uploads',
    subtitle: 'Bulk data uploads',
    tabs: {
      clients: 'Clients',
      cases: 'Cases',
    },
    clients: {
      title: 'Client Uploads',
      subtitle: 'Bulk client uploads',
      results: 'results',
      search: 'Search',
      table: {
        id: 'ID',
        agencyId: 'Agency ID',
        status: 'Status',
        createdAt: 'Created At',
        createdBy: 'Created By',
        filename: 'Filename',
        actions: 'Download',
      },
      status: {
        created: 'Created',
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
      },
      create: {
        title: 'Upload client file',
        description: 'Select a CSV file with client data',
        createdSuccess: 'File uploaded successfully',
        createdError: 'There was an error uploading the file',
      },
    },
    cases: {
      title: 'Case Uploads',
      subtitle: 'Bulk case uploads',
      results: 'results',
      search: 'Search',
      table: {
        id: 'ID',
        agencyId: 'Agency ID',
        status: 'Status',
        createdAt: 'Created At',
        createdBy: 'Created By',
        filename: 'Filename',
        workflow: 'Workflow',
        actions: 'Download',
      },
      status: {
        created: 'Created',
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
      },
      create: {
        title: 'Upload case file',
        description: 'Select a CSV file with case data',
        createdSuccess: 'File uploaded successfully',
        createdError: 'There was an error uploading the file',
      },
    },
  },
  flightIntegrations: {
    title: 'Flight Integrations',
    subtitle: 'List of flight integrations',
    results: 'Results',
    search: 'Search',
    table: {
      provider: 'Provider',
      ownerClientName: 'Owner client',
      isShared: 'Is shared',
      createdAt: 'Created At',
    },
    create: {
      title: 'Create Flight Integration',
      createdSuccess: 'Flight Integration created successfully',
      createdError: 'Flight Integration created failed',
    },
    edit: {
      loadItemError: 'Error load flight integration',
      title: 'Edit Flight Integration',
      updatedSuccess: 'Flight Updated successfully',
      updatedError: 'Flight Updated failed',
    },
    form: {
      provider: {
        label: 'Provider',
      },
      allowSeeByOthers: {
        label: 'Allow see by other clients',
      },
      username: {
        label: 'Username',
      },
      password: {
        label: 'Password',
      },
    },
  },
  hotelIntegrations: {
    title: 'Hotel Integrations',
    subtitle: 'List of hotel integrations',
    results: 'Results',
    search: 'Search',
    table: {
      provider: 'Provider',
      ownerClientName: 'Owner client',
      isShared: 'Is shared',
      createdAt: 'Created At',
    },
    create: {
      title: 'Create Hotel Integration',
      success: 'Hotel Integration created successfully',
      error: 'Hotel Integration creation failed',
    },
    edit: {
      loadItemError: 'Error loading hotel integration',
      title: 'Edit Hotel Integration',
      success: 'Hotel Integration updated successfully',
      error: 'Hotel Integration update failed',
    },
    update: {
      success: 'Hotel Integration updated successfully',
      error: 'Hotel Integration update failed',
    },
    form: {
      provider: {
        label: 'Provider',
      },
      allowSeeByOthers: {
        label: 'Allow see by other clients',
      },
      apiKey: {
        label: 'API Key',
      },
      clientCode: {
        label: 'Client Code',
      },
      clientName: {
        label: 'Client Name',
      },
    },
  },
  agencyFlightIntegrations: {
    title: 'Agency Flight Integrations',
    subtitle: 'List of agency flight integrations',
    results: 'Results',
    search: 'Search',
    table: {
      provider: 'Provider',
      ownerClientName: 'Owner client',
      isShared: 'Is shared',
      createdAt: 'Created At',
      isEnabledForAgency: 'Integration Enabled',
      itemEnabled: 'The integration is enabled',
      itemDisabled: 'This integration is disabled',
    },
    enabled: {
      success: 'The flight integration has been successfully enabled.',
      error: 'An error occurred while enabling the flight integration. Please try again.',
    },
    disabled: {
      success: 'The flight integration has been successfully disabled.',
      error: 'An error occurred while disabling the flight integration. Please try again.',
    },
    confirmDisableModal: {
      title: 'Disable Flight Integration',
      message:
        'If you disable this flight integration, the agency will no longer be able to search for flights using it. Do you still want to proceed?',
      accept: 'Accept',
      cancel: 'Cancel',
    },
  },
  hotelContent: {
    management: {
      title: 'Hotel Content Management',
      general: 'General',
      activeJobs: 'Active Jobs',
      viewJobs: 'View jobs',
      tabs: {
        suppliers: 'Suppliers',
        defaultSuppliers: 'Default Suppliers',
        boards: 'Boards',
        categories: 'Categories',
        destinations: 'Destinations',
        vendorHotels: 'Vendor Hotels',
        nimbuxHotels: 'Nimbux Hotels',
      },
      defaultSuppliers: {
        title: 'Default Suppliers',
        subtitle: 'Configure the priority order of suppliers for each type of content',
      },
      suppliers: {
        title: 'Hotel Content Suppliers',
        subtitle: 'Manage and view hotel content suppliers',
        updateMetadata: 'Update Metadata',
        updateMetadataMessages: {
          success: 'Metadata updated successfully',
          error: 'Error updating metadata',
        },
        refreshMessages: {
          success: 'A job has been queued to update the suppliers',
          error: 'Error updating suppliers',
        },
        table: {
          supplier: 'Supplier',
          provider: 'Provider',
          supplierCode: 'Supplier Code',
          providerCode: 'Provider Code',
          supplierName: 'Supplier Name',
          supplierContext: 'Supplier Context',
          providerName: 'Provider Name',
          isProviderActive: 'Provider Active',
          isSupplierActive: 'Supplier Active',
        },
        errors: {
          getSuppliers: 'Error loading suppliers',
        },
      },
      vendorHotels: {
        title: 'Vendor Hotels',
        subtitle: 'Manage and view vendor hotel listings',
        moderate: {
          title: 'Moderate',
          success: 'Hotels moderated successfully',
          error: 'Error moderating hotels',
        },
        createExtraction: 'Create Extraction',
        table: {
          name: 'Hotel Name',
          code: 'Hotel Code',
          location: 'Location',
          address: 'Address',
          supplier: 'Supplier',
          parent: 'Parent Hotel',
        },
        clearFilters: 'Clear Filters',
        linkModal: {
          currentNimbuxHotel: 'Current Nimbux Hotel',
          linkToNimbuxHotel: 'Link to Nimbux Hotel',
          searchPlaceholder: 'Search Nimbux Hotels...',
          availableNimbuxHotels: 'Available Nimbux Hotels',
          noNimbuxHotelsFound: 'No Nimbux Hotels found',
          noLinkedNimbuxHotel: 'This hotel is not linked to any Nimbux Hotel',
          link: 'Link',
          unlink: 'Unlink',
          nimbuxHotelLabel: 'Nimbux Hotel:',
          noNimbuxHotel: 'None',
        },
        errors: {
          getVendorHotels: 'Error loading vendor hotels',
        },
        modal: {
          title: 'Create New Extraction',
          supplier: 'Supplier',
          destination: 'Destination',
          startExtraction: 'Start Extraction',
        },
      },
      boards: {
        title: 'Boards',
        subtitle: 'Manage and view boards',
        table: {
          code: 'Code',
          supplierName: 'Supplier Name',
          texts: 'Texts',
        },
        errors: {
          getBoards: 'Error loading boards',
        },
      },
      categories: {
        title: 'Categories',
        subtitle: 'Manage and view categories',
        table: {
          code: 'Code',
          supplierName: 'Supplier Name',
          texts: 'Texts',
        },
        errors: {
          getCategories: 'Error loading categories',
        },
      },
      destinations: {
        title: 'Destinations',
        subtitle: 'Manage and view destinations',
        table: {
          code: 'Code',
          supplierName: 'Supplier Name',
          texts: 'Texts',
          type: 'Type',
        },
        errors: {
          getDestinations: 'Error loading destinations',
        },
      },
    },
    extraction: {
      supplier: 'Proveedor',
      destinations: 'Destinos',
      success: 'Extraction started successfully',
      error: 'Error starting the extraction',
      newExtraction: 'Create New Extraction',
      startExtraction: 'Start Extraction',
    },
    jobs: {
      errors: {
        getJobs: 'Error loading content extractor jobs',
      },
      modal: {
        title: 'Extraction Queues',
        resultsFound: 'jobs found',
        noJobsFound: 'No jobs found',
        parameters: 'Parameters',
        errors: 'Errors',
        created: 'Created',
        started: 'Started',
        finished: 'Finished',
        status: {
          pending: 'Pending',
          processing: 'Processing',
          completed: 'Completed',
          failed: 'Failed',
        },
      },
    },
    suppliers: 'Suppliers',
    boards: 'Boards',
    categories: 'Categories',
    destinations: 'Destinations',
    vendorHotels: 'Vendor Hotels',
    nimbuxHotels: {
      title: 'Nimbux Hotels',
      empty: 'Hotel list will be displayed here',
      emptyDescription: 'This section will contain the management interface for Nimbux hotels.',
      card: {
        lastModeration: 'Last moderation was: {{date}}',
        editButton: 'Edit',
        link: 'Link',
        opinions: '({{count}} opinions)',
        status: {
          markedForModeration: 'Marked for moderation',
          moderated: 'Moderated',
          toReview: 'To review',
          reviewed: 'Reviewed',
        },
      },
      linkModal: {
        title: 'Link Hotels - {{hotelName}}',
        searchPlaceholder: 'Search hotels...',
        linkedHotels: 'Linked Hotels',
        availableHotels: 'Available Hotels',
        noLinkedHotels: 'No hotels linked yet',
        noAvailableHotels: 'No hotels found',
        link: 'Link',
        unlink: 'Unlink',
        country: 'Country',
        city: 'City',
        parentHotel: 'Nimbux Hotel',
        noParentHotel: 'No nimbux hotel',
        noSupplier: 'No supplier',
        close: 'Close',
      },
      errors: {
        getNimbuxHotels: 'Error loading nimbux hotels',
        loadingError: 'Error loading hotels. Please try again.',
      },
      loadingMore: 'Loading more hotels...',
      noMoreHotels: 'No more hotels to show',
    },
    filters: {
      orderBy: 'Order by',
      name: 'Name',
      country: 'Country',
      suppliers: 'Suppliers',
      searchByName: 'Search by Name',
      searchPlaceholder: 'Enter hotel name',
      filterByCountry: 'Filter By Country',
      selectCountry: 'Select country',
      allCountries: 'All countries',
      filterByAddress: 'Filter by Address',
      address: 'Address',
      addressPlaceholder: 'Enter an address',
      distance: 'Distance',
    },
    view: {
      tabs: {
        general: 'General',
        checkinCheckout: 'Check-in / Check-out',
        location: 'Location',
        images: 'Images',
        amenities: 'Amenities',
        content: 'Content',
      },
      images: {
        published: "Published",
        available: "Available",
        count: "{{count}} images",
        mainBadge: "Main",
        moveToAvailable: "Move to Available",
        moveToPublished: "Move to Published",
        show: {
          label: "Show",
          all: "All",
          hotel: "Hotel",
          room: "Room",
          exterior: "Exterior"
        }
      }
    },
  },
  suppliers: {
    title: 'Hotel Content Suppliers',
    subtitle: 'Manage and view hotel content suppliers',
    updateMetadata: 'Update Metadata',
    updateMetadataMessages: {
      success: 'Metadata updated successfully',
      error: 'Error updating metadata',
    },
    refreshMessages: {
      success: 'A job has been queued to update the suppliers',
      error: 'Error updating suppliers',
    },
    table: {
      supplier: 'Supplier',
      provider: 'Provider',
      supplierCode: 'Supplier Code',
      providerCode: 'Provider Code',
      supplierName: 'Supplier Name',
      supplierContext: 'Supplier Context',
      providerName: 'Provider Name',
      isProviderActive: 'Provider Active',
      isSupplierActive: 'Supplier Active',
    },
  },
};
